import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

  return (
    <svg
      width={255}
      height={160}
      viewBox="0 0 255 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.755 101.32l85.41-37.536c.751-.392 1.753-.587 2.755-.587s1.753.195 2.755.586l118.221 50.44c1.753.782 2.755 2.346 2.755 3.91s-1.002 3.128-2.755 3.91l-85.41 37.34c-.751.391-1.753.587-2.504.587-1.002 0-1.754-.196-2.755-.587L2.755 108.944C1.002 108.162 0 106.598 0 105.034s1.002-2.932 2.755-3.714z"
        fill="#fff"
      />
      <path
        d="M88.415 64.174c.751-.391 1.753-.587 2.504-.391.752 0 2.004.195 2.756.586l117.97 50.244c1.002.586 1.753 1.368 2.004 2.15.25.391.25 1.173.25 1.564 0 1.369-1.502 2.933-3.005 3.715l-84.408 36.754c-.751.391-1.753.586-2.505.586h-1.002c-.5 0-1.001-.195-1.502-.391L3.005 108.748c-1.002-.391-1.753-1.173-2.004-1.955-.25-.587-.25-1.173-.25-1.76 0-1.368 1.503-2.932 3.006-3.714l84.658-37.145z"
        fill="#F8F8F9"
      />
      <path
        d="M88.666 64.37c.751-.392 1.503-.392 2.505-.392.75 0 2.003.391 2.504.587l117.72 50.243c1.002.391 1.754 1.369 1.754 2.151.25.391 0 .977 0 1.564 0 1.173-1.754 2.737-3.257 3.323l-83.405 36.363c-.501.196-1.754.587-2.505.587h-1.002c-.501 0-1.002-.196-1.503-.391L3.257 108.161c-1.003-.391-1.754-1.368-1.754-2.15-.25-.391 0-1.173 0-1.564 0-1.173 2.004-2.933 3.256-3.519l83.907-36.559z"
        fill="#F1F1F3"
      />
      <path
        d="M88.916 64.76c.752-.39 1.503-.39 2.254-.39.752 0 2.004.39 2.505.782l117.47 50.048c1.001.391 1.502 1.368 1.502 2.15.251.391-.25.978-.25 1.369 0 .977-2.254 2.737-3.507 3.128l-82.404 35.972c-.501.195-1.753.586-2.504.586-.251 0-.752.196-1.002 0-.501 0-1.002-.195-1.503-.391L3.256 107.771c-1.002-.391-1.503-1.369-1.503-2.151-.25-.391.25-.977.25-1.564 0-.977 2.255-2.737 3.507-3.323l83.406-35.972z"
        fill="#EAEBEC"
      />
      <path
        d="M89.167 65.15c.751-.195 1.502-.39 2.004-.39.5 0 2.003.586 2.504.782l117.219 50.048c1.002.391 1.503 1.368 1.253 2.15.25.391-.501.978-.501 1.369 0 .977-2.755 2.541-3.507 2.932l-81.402 35.581c-.501.196-1.753.782-2.254.782-.251 0-.752.196-1.002.196-.501 0-1.002 0-1.503-.196L3.758 108.161c-1.003-.391-1.504-1.369-1.253-2.151-.25-.391.5-.977.5-1.368 0-.978 2.756-2.542 3.758-3.128l82.404-36.363z"
        fill="#E3E4E6"
      />
      <path
        d="M89.418 65.347c.5-.195 1.252-.391 2.003-.195.501 0 2.255.586 2.505.782l116.969 49.852c1.002.391 1.502 1.564 1.002 2.151 0 .195-.752.977-.752 1.173 0 .782-3.005 2.541-3.757 2.737l-80.4 34.994c-.251.196-2.004.782-2.254.782-.251 0-.752.196-1.002.196-.501 0-1.002 0-1.503-.196L4.008 107.38c-1.002-.391-1.503-1.369-1.002-2.151-.25-.195.752-.977.752-1.173 0-.782 3.005-2.541 4.007-2.932l81.653-35.777z"
        fill="#DDDDE0"
      />
      <path
        d="M89.668 65.739c.501-.196 1.253-.391 1.754-.196.25 0 2.254.782 2.504.782l116.718 49.657c1.002.391 1.253 1.564.752 2.151 0 .195-1.002.782-1.002.977 0 .587-3.507 2.346-4.007 2.542l-79.399 34.603c-.25.196-2.004.782-2.254.782 0 0-.752.196-1.002.196-.501.195-1.002 0-1.503-.196L4.009 106.794c-1.003-.391-1.253-1.564-.752-2.151 0-.195 1.002-.977 1.002-1.173 0-.586 3.506-2.346 4.007-2.737l81.402-34.994z"
        fill="#D6D6DA"
      />
      <path
        d="M89.668 65.934c.5-.196 1.252-.196 1.753-.196.25 0 2.254.782 2.505.978l116.467 49.657c1.002.391 1.253 1.564.501 2.15 0 .196-1.252.782-1.252.978 0 .391-3.757 2.15-4.258 2.346l-78.396 34.212c-.251 0-2.004.782-2.255.782 0 0-.751.196-1.002.196-.5.195-1.001.195-1.502-.196L4.259 106.793c-1.003-.391-1.253-1.564-.502-2.15 0-.196 1.253-.978 1.253-.978 0-.391 4.007-2.346 4.258-2.541l80.4-35.19z"
        fill="#CFD0D3"
      />
      <path
        d="M89.919 66.324a1.999 1.999 0 011.503 0s2.254.978 2.504.978l116.218 49.461c1.001.391 1.001 1.564.25 2.151l-1.503.782c0 .195-4.258 2.15-4.258 2.15l-77.394 33.822-2.004.782s-.752.391-1.002.391a2.004 2.004 0 01-1.503 0L4.51 106.597c-1.003-.391-1.003-1.564-.251-2.15 0 0 1.503-.782 1.503-.978 0-.195 4.258-2.15 4.508-2.346l79.649-34.799z"
        fill="#C8C9CD"
      />
      <path
        d="M90.169 66.52a1.999 1.999 0 011.503 0l118.221 50.439a1.146 1.146 0 010 2.151l-85.41 37.34a1.994 1.994 0 01-1.503 0L4.76 106.207a1.145 1.145 0 010-2.151L90.168 66.52z"
        fill="#C1C2C7"
      />
      <path
        d="M210.894 115.2l-6.512-.587L92.924 67.107a6.765 6.765 0 00-5.51 0L7.014 102.1l-4.008-.391v3.128c0 .587.25.978 1.002 1.369l116.217 49.852a6.764 6.764 0 005.51 0l83.907-36.167c.752-.391 1.002-.782 1.002-1.369V115.2h.25z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M123.231 156.646c-1.002 0-2.004-.196-2.756-.587L4.258 106.207c-.751-.196-1.002-.782-1.252-1.369V101.319l4.258.391 80.4-34.798c1.753-.783 4.008-.783 5.76 0l111.459 47.506 6.512.586v3.519c0 .587-.501.978-1.252 1.369l-83.907 36.167c-1.252.391-2.004.587-3.005.587zM3.507 104.643c0 .586.25.977 1.002 1.173l115.966 49.852c1.503.782 3.507.782 5.26 0l83.907-36.167c.501-.196 1.002-.587 1.002-1.173V115.395l-6.262-.586L92.924 67.302c-1.503-.782-3.507-.586-5.26 0l-80.4 34.995-3.757-.391v2.737z"
        fill="#131A2D"
      />
      <path
        d="M209.893 113.636L92.924 63.979a6.765 6.765 0 00-5.51 0L4.258 100.147c-1.502.586-1.502 2.15 0 2.737l116.218 49.852a6.764 6.764 0 005.51 0l83.907-36.167a1.615 1.615 0 000-2.933z"
        fill="#fff"
      />
      <path
        d="M4.259 102.491l10.018 4.301 106.199 45.356a6.764 6.764 0 005.51 0l74.139-32.062 7.764-3.324 2.004-.782c1.503-.586 1.503-2.15 0-2.932L92.924 63.586a6.765 6.765 0 00-5.51 0L13.526 95.648l-9.518 4.106c-1.252.586-1.252 2.15.25 2.737z"
        fill="#fff"
      />
      <path
        d="M123.231 153.126c-1.002 0-2.004-.196-2.756-.587L14.277 107.183l-10.019-4.301c-.751-.391-1.252-.977-1.252-1.564 0-.586.5-1.368 1.252-1.564l9.518-4.106 73.888-32.061c1.753-.783 4.008-.783 5.76 0l116.969 49.852c.752.391 1.253.978 1.253 1.564 0 .587-.501 1.369-1.253 1.564l-9.768 4.106-74.138 32.062c-1.503.195-2.255.391-3.256.391zM4.509 102.296l10.018 4.3 106.199 45.357c1.503.782 3.506.782 5.26 0l74.138-32.062 9.769-4.106c.5-.195 1.001-.782 1.001-1.173s-.25-.978-1.001-1.173L92.673 63.782c-1.502-.782-3.506-.586-5.26 0L4.259 99.95c-.5.195-1.002.782-1.002 1.173.25.586.501.977 1.253 1.173z"
        fill="#131A2D"
      />
      <path
        d="M69.47 101.73c-.537 1.343-.805 2.686-1.343 3.761l-2.149 6.715-2.686-.806c-2.149-.806-3.223-5.641-1.612-11.55 1.88-5.91 5.642-9.671 7.79-9.134l2.687.806-2.15 6.716c.27.806 0 2.149-.537 3.492z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M65.977 112.206l-2.955-.806c-2.149-.806-3.223-5.91-1.343-11.82 1.88-5.641 5.104-9.402 7.522-9.402h.268l2.687.806-2.15 6.716c-.268 1.343-.537 2.417-.805 3.761-.269 1.343-.806 2.417-1.612 3.76l-1.612 6.985zm-2.418-.806l2.418.537 1.88-6.716c.538-1.074 1.075-2.417 1.344-3.76.268-1.344.537-2.687.806-3.761l1.88-6.716-2.418-.537c-2.149-.537-5.91 3.223-7.79 9.133-1.343 6.179-.269 11.014 1.88 11.82z"
        fill="#131A2D"
      />
      <path
        d="M61.948 109.521c0-.268-.269-.537-.269-.806l5.104 1.343-.269.538-4.566-1.075z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M66.514 110.864l-4.566-1.343c0-.269-.269-.537-.269-.806v-.268l5.373 1.343-.538 1.074zm-4.566-1.343l4.298 1.075v-.269l-4.567-1.343c.269.268.269.268.269.537z"
        fill="#131A2D"
      />
      <path
        d="M70.275 98.507l-6.984-1.88c0-.269.269-.538.269-.538l6.715 1.88v.538z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M70.275 98.775l-7.253-1.88v-.269c0-.268.27-.537.27-.537l6.983 1.88v.27c.269 0 0 .268 0 .536zm-6.984-2.149l6.716 1.88v-.537l-6.447-1.611s0 .268-.269.268z"
        fill="#131A2D"
      />
      <path
        d="M62.755 97.7c0-.268.268-.537.268-.537l7.253 1.88v.806L62.755 97.7z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M70.007 99.849l-7.521-2.15v-.268c0-.269.268-.537.268-.537l7.253 1.88c.269.537.269.806 0 1.075zm-6.984-2.15l6.984 1.881v-.537l-6.984-1.88v.537z"
        fill="#131A2D"
      />
      <path
        d="M65.977 92.597l.537-.537 5.104 1.343-.268.537-5.373-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M71.619 94.208l-5.91-1.612.269-.268.537-.538 5.372 1.344-.268 1.074zm-5.373-1.612l5.373 1.343v-.268l-5.104-1.343-.269.268z"
        fill="#131A2D"
      />
      <path
        d="M62.217 99.044c0-.269.269-.537.269-.537l7.253 1.88c0 .269 0 .537-.269.537l-7.253-1.88z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M69.738 101.193l-7.79-2.15c0-.268.268-.537.268-.537l7.522 1.881c.269 0 .269.268 0 .806zm-7.253-2.418l7.253 1.88v-.537l-7.253-1.88v.537z"
        fill="#131A2D"
      />
      <path
        d="M66.785 91.791c.268-.269.537-.269.806-.537l4.298 1.074-.27.538-4.834-1.075z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M71.888 93.135l-5.373-1.343.269-.269c.268-.269.537-.269.806-.537l4.566 1.343-.268.806zm-4.567-1.343l4.567 1.074v-.268l-4.298-1.075s-.269 0-.269.269z"
        fill="#131A2D"
      />
      <path
        d="M64.367 94.745c0-.268.268-.537.537-.537l6.178 1.612-.268.537-6.447-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M70.813 96.626l-6.715-1.88v-.27c.268-.268.268-.537.537-.537l6.447 1.612-.269 1.075zm-6.178-2.15l6.178 1.612v-.268l-5.91-1.612c-.268 0-.268.269-.268.269z"
        fill="#131A2D"
      />
      <path
        d="M63.83 95.82c0-.268.268-.537.268-.537l6.447 1.88-.269.538-6.447-1.88z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M70.545 97.701l-6.985-1.88v-.269c0-.269.27-.537.27-.537l6.715 1.88v.806zm-6.716-2.149l6.447 1.612v-.269l-6.447-1.611c.269 0 .269.268 0 .268z"
        fill="#131A2D"
      />
      <path
        d="M65.172 93.671l.537-.537 5.91 1.612-.269.537-6.178-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M71.35 95.552l-6.447-1.612v-.269l.538-.537 5.91 1.612v.806zm-6.178-1.88l5.641 1.611v-.269l-5.641-1.611c.269 0 .269 0 0 .268z"
        fill="#131A2D"
      />
      <path
        d="M61.143 105.759v-.806l6.447 1.612-.269.537-6.178-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M67.59 107.639l-6.447-1.612v-1.074l6.716 1.88-.269.806zm-6.447-1.88l6.178 1.612v-.269l-6.178-1.612v.269z"
        fill="#131A2D"
      />
      <path
        d="M61.68 101.192c0-.268 0-.537.268-.537l7.521 1.88c0 .269-.268.538-.268.538l-7.522-1.881z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M69.2 103.341l-7.52-2.149c0-.268 0-.537.268-.537l7.521 2.149v.269c-.268-.269-.268 0-.268.268zm-7.252-2.417l7.253 1.88s0-.269.268-.269l-7.253-1.88c-.268 0-.268.269-.268.269z"
        fill="#131A2D"
      />
      <path
        d="M69.47 101.998l-7.522-1.88v-.269-.537l7.521 1.88v.806s0-.269 0 0z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M69.47 102.267l-7.79-2.149v-.806l7.52 2.149v.537c.538-.268.538 0 .27.269zm-7.254-2.418l7.253 1.881v-.269l-7.253-1.88v.268z"
        fill="#131A2D"
      />
      <path
        d="M63.56 111.4c-.537-.268-.806-.537-1.343-1.074l4.03 1.074-.269.806-2.418-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M66.246 112.206l-2.686-.806c-.538-.269-.806-.537-1.344-1.075l-.268-.268 4.566 1.074-.268 1.075zm-2.686-1.075l2.417.537.269-.537-3.492-1.074c0 .806.537 1.074.806 1.074z"
        fill="#131A2D"
      />
      <path
        d="M68.395 90.986c.538-.269 1.075-.269 1.344-.269l2.686.806-.269.538-3.76-1.075z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M72.156 92.06l-4.298-1.075.268-.268c.538-.269 1.075-.269 1.344-.269l2.686.806v.806zm-3.492-1.075l3.223.806v-.269l-2.417-.537c0-.268-.269-.268-.806 0z"
        fill="#131A2D"
      />
      <path
        d="M61.412 108.176c0-.269 0-.538-.269-.806l5.641 1.612-.268.537-5.104-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M66.784 109.788l-5.372-1.344c0-.268 0-.537-.269-.806v-.268l5.91 1.612-.269.806zm-5.372-1.612l5.104 1.343v-.269l-5.373-1.343c.269 0 .269.269.269.269z"
        fill="#131A2D"
      />
      <path
        d="M61.412 102.268v-.806l7.253 1.881c0 .268-.27.537-.27.537l-6.983-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M68.665 104.417l-7.522-1.88V101.462l7.522 1.881v.268c.268.269.268.537 0 .806zm-6.985-2.149l6.985 1.88s0-.268.268-.268l-6.984-1.881c-.269 0-.269 0-.269.269z"
        fill="#131A2D"
      />
      <path
        d="M61.144 107.102v-.806l6.178 1.612-.269.537-5.91-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M67.053 108.714l-6.178-1.612V106.027l6.447 1.612-.27 1.075zm-5.641-1.881l5.64 1.612v-.269l-5.909-1.611c.269 0 .269.268.269.268z"
        fill="#131A2D"
      />
      <path
        d="M61.143 104.685v-.806l6.716 1.881-.269.537-6.447-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M67.859 106.565l-6.716-1.88V103.61h.269l6.984 1.881-.537 1.074zm-6.447-2.149l6.447 1.612v-.269l-6.447-1.612v.269z"
        fill="#131A2D"
      />
      <path
        d="M61.143 103.342v-.806l6.984 1.881c0 .268-.268.537-.268.537l-6.716-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M68.127 105.491l-6.984-1.88V102.536l7.253 1.881v.268c0 .269 0 .538-.269.806zm-6.715-2.149l6.715 1.881s0-.269.269-.269l-6.716-1.88c-.268 0-.268 0-.268.268z"
        fill="#131A2D"
      />
      <path
        d="M74.304 103.072c-1.88 6.179-5.64 9.671-8.058 9.134-2.418-.538-3.492-5.641-1.612-11.82 1.88-6.178 5.641-9.67 8.059-9.133 2.417.537 3.223 5.641 1.611 11.819z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M66.782 112.475h-.537c-.537-.269-1.343-.806-1.612-1.612-1.343-2.149-1.343-6.447 0-10.476 1.88-6.179 5.91-9.94 8.06-9.134.536.27 1.342.806 1.61 1.612 1.344 2.15 1.344 6.447 0 10.477-1.88 5.372-5.372 9.133-7.52 9.133zm5.373-21.222c-2.15 0-5.641 3.493-7.253 9.134-1.343 4.029-1.343 8.059 0 10.208.537.805.806 1.074 1.612 1.343 2.149.537 5.91-2.955 7.79-9.134 1.343-4.029 1.343-8.058 0-10.207-.537-.806-.806-1.075-1.612-1.344h-.537z"
        fill="#131A2D"
      />
      <path
        opacity={0.25}
        d="M63.829 107.639v-2.418l11.282-6.178c0 .806-.269 1.88-.537 2.686l-10.745 5.91zM64.365 101.192c0-.269.268-.537.268-.806s.269-.537.269-.806l9.94-5.373c0 .27.268.806.268 1.344l-10.745 5.641z"
        fill="#fff"
      />
      <path
        d="M77.26 62.242l40.563-23.37c.537-.27.537-.538.537-.807v12.357c0 .269-.269.806-.537 1.075L86.125 69.495c-3.761 2.149-8.596.805-10.477-2.955-1.074-1.612-.268-3.224 1.612-4.298z"
        fill="#131A2D"
      />
      <path
        d="M117.016 50.422c0-1.88-2.149-3.224-4.029-2.15L76.991 68.958c-1.88 1.074-2.686 2.955-1.612 4.567 2.15 3.76 6.716 5.103 10.477 2.954l30.892-17.729v-8.327h.268z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M82.363 77.553c-.806 0-1.343 0-2.15-.269-2.148-.537-3.76-1.88-4.835-3.76-.268-.806-.537-1.344-.268-2.15.268-1.074 1.074-1.88 2.149-2.417l35.996-20.684a2.44 2.44 0 012.686 0c.806.537 1.343 1.343 1.343 2.417v8.06L86.392 76.477c-1.343.538-2.686 1.075-4.03 1.075zm31.966-29.549c-.537 0-.806 0-1.343.269L76.99 68.957c-1.074.537-1.612 1.343-1.88 2.418-.269.805 0 1.343.268 1.88 1.075 1.88 2.687 3.224 4.567 3.76 1.88.538 4.03.27 5.641-.805l30.892-17.73v-8.058c0-.806-.537-1.612-1.343-2.15 0-.268-.269-.268-.806-.268z"
        fill="#131A2D"
      />
      <path
        d="M74.035 60.362l40.563-23.37c.806-.538 2.417-.538 3.223 0 .806.537.806 1.342 0 1.88l-40.562 23.37c-2.418 1.343-2.418 3.76 0 5.104 2.417 1.343 6.447 1.343 8.864 0l40.563-23.37c.806-.538 2.418-.538 3.223 0 .806.537.806 1.343 0 1.88l-40.562 23.37c-4.298 2.418-10.208 3.493-15.043 0-4.298-2.954-4.567-6.447-.269-8.864z"
        fill="#131A2D"
      />
      <path
        d="M107.614 45.049c-.268 1.343-.806 2.686-1.343 3.76l-1.612 6.716-2.686-.537c-2.149-.806-3.76-5.641-2.149-11.82 1.343-6.178 4.835-9.939 7.253-9.401l2.686.537-1.611 6.716c0 1.343-.269 2.686-.538 4.029z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M104.928 55.795l-2.955-.806c-2.15-.806-3.492-5.641-2.15-11.82 1.344-6.178 4.836-9.939 7.254-9.67l2.686.537-1.612 6.984c0 1.343-.268 2.687-.537 3.761-.269 1.343-.806 2.686-1.343 3.76l-1.343 7.254zm-2.686-1.075l2.417.538 1.612-6.716c.537-1.075.806-2.418 1.343-3.76.269-1.344.537-2.687.537-3.762l1.612-6.715-2.418-.538c-2.149-.268-5.641 3.224-6.984 9.402-1.612 6.179-.268 11.014 1.881 11.551z"
        fill="#131A2D"
      />
      <path
        d="M100.631 53.108c0-.269-.269-.537-.269-.806l5.104 1.075-.268.537-4.567-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M105.197 54.451l-4.836-1.074c0-.269-.268-.538-.268-.806v-.269l5.372 1.343-.268.806zm-4.567-1.343l4.298 1.075v-.538l-4.567-1.074c0 .269.269.269.269.537z"
        fill="#131A2D"
      />
      <path
        d="M108.153 41.827l-6.985-1.612c0-.268.269-.537.269-.537l6.984 1.612c-.268 0-.268.268-.268.537z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M108.152 42.095l-7.253-1.611v-.269c0-.269.269-.537.269-.537l6.984 1.612v.805zm-6.984-2.149l6.715 1.612v-.537l-6.715-1.612c.268.269 0 .537 0 .537z"
        fill="#131A2D"
      />
      <path
        d="M100.63 41.29c0-.27.269-.538.269-.538l7.253 1.612v.806l-7.522-1.88z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M108.152 43.17l-7.522-1.881v-.269c0-.269.269-.537.269-.537l7.522 1.88c-.269.269-.269.269-.269.806zm-7.253-2.15l6.984 1.612v-.537l-6.984-1.612v.537z"
        fill="#131A2D"
      />
      <path
        d="M103.585 35.918l.538-.538 5.372 1.343-.268.538-5.642-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M109.226 37.529l-5.91-1.343.269-.269.537-.537 5.373 1.343-.269.806zm-5.641-1.612l5.373 1.343v-.537l-5.104-1.075-.269.27z"
        fill="#131A2D"
      />
      <path
        d="M100.362 42.364c0-.269 0-.538.269-.538l7.521 1.88v.807l-7.79-2.15z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M107.883 44.244l-7.79-1.88c0-.269 0-.538.268-.538l7.791 1.88c-.269 0-.269.27-.269.538zm-7.522-1.88l7.253 1.611v-.537l-7.253-1.612c.269.269 0 .269 0 .538z"
        fill="#131A2D"
      />
      <path
        d="M104.391 34.843c.269-.269.537-.269.806-.537l4.298 1.074-.269.538-4.835-1.075z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M109.494 36.186l-5.372-1.343.268-.269c.269-.268.537-.268.806-.537l4.567 1.075-.269 1.074zm-4.835-1.343l4.566 1.074v-.537l-4.298-1.074c0 .268 0 .537-.268.537z"
        fill="#131A2D"
      />
      <path
        d="M101.973 38.065c0-.269.269-.538.269-.538l6.178 1.612-.268.537-6.179-1.611z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M108.689 39.677l-6.716-1.612v-.269c0-.268.269-.537.269-.537l6.447 1.612v.806zm-6.447-1.88l6.178 1.342v-.537l-6.178-1.343c.268.269 0 .537 0 .537z"
        fill="#131A2D"
      />
      <path
        d="M101.435 39.14c0-.269.269-.537.269-.537l6.715 1.611-.268.538-6.716-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M108.419 40.752l-6.984-1.612v-.269c0-.268.269-.537.269-.537l6.715 1.612v.806zm-6.715-1.88l6.447 1.611v-.537l-6.447-1.612v.537z"
        fill="#131A2D"
      />
      <path
        d="M102.78 36.99c.269-.268.269-.536.538-.536l5.909 1.343-.268.537-6.179-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M108.959 38.603l-6.447-1.612v-.268c.268-.27.268-.538.537-.538l6.178 1.343-.268 1.075zm-5.91-1.612l5.91 1.343v-.537l-5.641-1.343c-.269.269-.269.269-.269.537z"
        fill="#131A2D"
      />
      <path
        d="M99.556 49.348v-.806l6.447 1.612-.269.537-6.178-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M106.003 50.959l-6.447-1.612v-1.074l6.715 1.611-.268 1.075zm-6.447-1.612l6.178 1.343v-.537l-6.178-1.343v.537z"
        fill="#131A2D"
      />
      <path
        d="M99.825 44.512v-.806l7.522 1.88c0 .27 0 .538-.269.538l-7.253-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M107.346 46.661l-7.79-1.88v-.806l7.79 1.88c.268 0 0 .269 0 .806zm-7.522-2.149l7.253 1.612v-.537l-7.253-1.612c.269.268 0 .537 0 .537z"
        fill="#131A2D"
      />
      <path
        d="M107.616 45.318l-7.522-1.88v-.269-.537l7.522 1.88v.806c0-.268 0-.268 0 0z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M107.615 45.318l-7.79-1.88v-.806l7.79 1.88v.806zm-7.521-1.88l7.253 1.612v-.269l-7.253-1.612c.268 0 0 0 0 .269z"
        fill="#131A2D"
      />
      <path
        d="M102.243 54.72c-.538-.269-1.075-.537-1.344-1.075l4.03 1.075-.269.806-2.417-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M104.928 55.526l-2.954-.537c-.538-.269-.806-.537-1.344-1.075l-.268-.268 4.566 1.074v.806zm-2.686-.806l2.418.538v-.538l-3.492-.806c.268.269.806.538 1.074.806z"
        fill="#131A2D"
      />
      <path
        d="M105.734 34.037c.537-.269 1.074-.269 1.343-.269l2.686.538v.537l-4.029-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M109.763 35.111l-4.298-1.075.268-.268c.538-.269 1.075-.269 1.344-.269l2.686.537v1.075zm-3.492-1.075l3.223.806v-.268l-2.417-.538h-.806z"
        fill="#131A2D"
      />
      <path
        d="M100.094 51.766c0-.268-.269-.537-.269-.806l5.641 1.343-.268.538-5.104-1.075z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M105.465 53.378l-5.64-1.343c0-.27-.27-.538-.27-.806v-.269l5.91 1.343v1.075zm-5.372-1.612l5.104 1.343v-.537l-5.373-1.343c.269.268.269.268.269.537z"
        fill="#131A2D"
      />
      <path
        d="M99.556 45.857v-.806l7.253 1.612c0 .269-.269.537-.269.537l-6.984-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M107.077 47.737l-7.521-1.88V44.782l7.79 1.88v.27c-.269.268-.269.268-.269.805zm-7.253-2.149l6.985 1.612s0-.269.268-.269l-6.984-1.611c-.269 0-.269.268-.269.268z"
        fill="#131A2D"
      />
      <path
        d="M99.825 50.692v-.806l6.179 1.343-.269.537-5.91-1.074z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M105.734 52.034l-6.178-1.343V49.616l6.447 1.612-.269.806zm-5.91-1.612l5.641 1.343v-.537l-5.91-1.343c.27.269.27.537.27.537z"
        fill="#131A2D"
      />
      <path
        d="M99.556 48.006V47.2l6.715 1.611-.268.538-6.447-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M106.271 49.886l-6.984-1.612V47.199l6.984 1.612v1.075zm-6.715-1.88l6.447 1.611v-.537l-6.447-1.612v.537z"
        fill="#131A2D"
      />
      <path
        d="M99.556 46.93v-.806l7.253 1.612c0 .269-.269.537-.269.537l-6.984-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M106.54 48.81L99.287 47.2V46.124l7.522 1.88v.27s-.269.268-.269.537zm-6.984-1.88l6.715 1.612s0-.269.269-.269l-6.716-1.611c-.268 0-.268 0-.268.268z"
        fill="#131A2D"
      />
      <path
        d="M112.181 46.124c-1.612 6.179-5.104 9.94-7.253 9.402-2.149-.537-3.761-5.372-2.418-11.82 1.612-6.178 5.104-9.939 7.253-9.401 2.418.537 4.03 5.64 2.418 11.82z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M105.466 55.795h-.538c-2.417-.537-4.029-5.641-2.417-11.82.805-2.954 1.88-5.64 3.492-7.252 1.343-1.612 2.955-2.418 4.029-2.15 2.418.538 4.03 5.642 2.418 11.82-.806 2.955-1.881 5.641-3.492 7.253-1.075 1.343-2.418 2.15-3.492 2.15zm4.029-21.221c-1.075 0-2.149.806-3.492 2.149-1.343 1.88-2.687 4.298-3.224 7.252-1.343 6.179 0 11.014 2.149 11.551 1.075.27 2.418-.537 3.761-2.149 1.343-1.88 2.686-4.298 3.224-7.253 1.343-6.178 0-11.013-2.15-11.55h-.268z"
        fill="#131A2D"
      />
      <path
        opacity={0.25}
        d="M102.242 50.96c0-.807-.269-1.613-.269-2.418l10.745-6.716c0 .806 0 1.88-.268 2.686l-10.208 6.447zM102.511 44.78c0-.269 0-.537.268-.806 0-.268.269-.537.269-.806l9.402-5.91c0 .27.269.806.269 1.344l-10.208 6.178z"
        fill="#fff"
      />
      <path
        d="M165.638 9.054c-1.612.269-2.955.269-4.299.269l-7.521 1.074-.269-2.955c-.268-2.417 4.298-5.91 11.014-6.984 6.716-.806 12.088 1.075 12.625 3.492l.269 2.955-7.521 1.075c-1.612.537-2.955.806-4.298 1.074z"
        fill="#fff"
      />
      <path
        d="M153.549 10.397l-.537-3.223c0-2.687 4.567-5.91 11.282-6.985 6.716-.806 12.089 1.075 12.626 3.492l.537 2.955-7.79 1.075c-1.343.537-2.686.806-4.298 1.074-1.343.269-2.955.269-4.298.269l-7.522 1.343zm-.268-2.955l.268 2.687 7.522-1.075c1.343 0 2.955 0 4.298-.269 1.343-.268 2.955-.537 4.298-1.074l7.522-1.075-.269-2.686c-.537-2.418-5.641-4.567-12.357-3.492-6.984 1.074-11.282 4.298-11.282 6.984z"
        fill="#131A2D"
      />
      <path
        d="M154.354 5.023l.538-.537.806 5.641h-.806l-.538-5.104z"
        fill="#fff"
      />
      <path
        d="M154.892 10.128l-.806-5.373.806-.806.268-.268.806 5.91-1.074.537zm-.269-5.104l.537 4.835h.538l-.806-5.372c0 .268-.269.268-.269.537z"
        fill="#131A2D"
      />
      <path
        d="M168.861 8.249l-1.075-7.79h.806l1.075 7.79c-.269-.269-.538 0-.806 0z"
        fill="#fff"
      />
      <path
        d="M168.861 8.516L167.787.188h1.074l1.075 7.79h-.269c-.269.27-.537.27-.806.538zm-.806-8.059l1.075 7.522c.268 0 .268 0 .537-.269L168.593.188c-.269.27-.269.27-.538.27z"
        fill="#131A2D"
      />
      <path
        d="M166.712.459h.806l1.075 8.059c-.269 0-.537 0-.806.268L166.712.46z"
        fill="#fff"
      />
      <path
        d="M167.518 8.785L166.443.189H167.518l1.074 8.327c-.268 0-.537 0-1.074.269zm-.806-8.328l1.074 7.79h.538l-1.075-7.79h-.537z"
        fill="#131A2D"
      />
      <path
        d="M173.159 1.264c.268 0 .537.268.806.268l.805 5.91h-.805l-.806-6.178z"
        fill="#fff"
      />
      <path
        d="M173.965 7.71l-.806-6.715h.268c.269 0 .538.268.806.268l.806 5.91-1.074.537zm-.538-6.447l.806 5.91h.537l-.805-5.641c-.269 0-.538 0-.538-.269z"
        fill="#131A2D"
      />
      <path
        d="M165.368.459h.806l1.075 8.327c-.269 0-.538 0-.806.269L165.368.459z"
        fill="#fff"
      />
      <path
        d="M166.443 9.055L165.368.459H166.443l1.074 8.596c-.537-.269-.806-.269-1.074 0zM165.368.459l1.075 8.059h.537l-1.075-8.06h-.537z"
        fill="#131A2D"
      />
      <path
        d="M174.501 1.802c.269.268.538.268.806.537l.538 4.835h-.806l-.538-5.372z"
        fill="#fff"
      />
      <path
        d="M175.039 7.442l-.806-5.91h.269c.268.269.537.269.805.537l.806 5.104-1.074.269zm-.269-5.373l.806 5.104h.537l-.537-4.835c-.537 0-.806-.269-.806-.269z"
        fill="#131A2D"
      />
      <path d="M170.473.459h.806l1.075 6.984h-.806L170.473.46z" fill="#fff" />
      <path
        d="M171.279 7.98L170.204.46H171.279l1.074 7.253-1.074.268zm-.538-7.253l1.075 6.985h.537l-.806-6.716c-.537-.269-.806-.269-.806-.269z"
        fill="#131A2D"
      />
      <path d="M169.129.459h.806l1.075 7.253h-.806L169.129.459z" fill="#fff" />
      <path
        d="M170.204 7.979l-1.075-7.79H170.204l1.074 7.521-1.074.269zm-.806-7.522l1.075 7.253h.537L169.935.457h-.537z"
        fill="#131A2D"
      />
      <path
        d="M171.815.728c.269 0 .538 0 .806.268l.806 6.447h-.806l-.806-6.715z"
        fill="#fff"
      />
      <path
        d="M172.621 7.712L171.547.459h.269c.268 0 .537.268.805.268l1.075 6.985h-1.075zm-.537-6.716l.806 6.447h.537l-.806-6.178c-.268-.269-.537-.269-.537-.269z"
        fill="#131A2D"
      />
      <path
        d="M157.848 2.338c.268 0 .537-.268.806-.268l1.074 7.253h-.806l-1.074-6.985z"
        fill="#fff"
      />
      <path
        d="M158.654 9.591l-1.075-7.253c.269 0 .537-.268.806-.268h.269l1.074 7.521h-1.074zm-.538-6.984l.806 6.984h.537l-1.074-6.984c0-.269-.269-.269-.269 0z"
        fill="#131A2D"
      />
      <path
        d="M162.952.728c.268 0 .537 0 .806-.269l1.074 8.327h-.806L162.952.728z"
        fill="#fff"
      />
      <path
        d="M163.757 9.323L162.682.727c.269 0 .537 0 .806-.268l1.075 8.596h-.269c.269.268 0 .268-.537.268zm-.806-8.327l1.074 8.059h.538L163.488.996c-.269-.269-.269 0-.537 0z"
        fill="#131A2D"
      />
      <path
        d="M165.101 9.055L164.026.728h.806l1.075 8.327h-.538-.268z"
        fill="#fff"
      />
      <path
        d="M165.1 9.055L164.026.459h1.343l1.075 8.596H165.1zm-.805-8.328l1.074 8.06h.537l-1.074-8.06h-.537z"
        fill="#131A2D"
      />
      <path
        d="M153.281 7.442c0-.538.268-1.075.537-1.88l.537 4.566h-.806l-.268-2.686z"
        fill="#fff"
      />
      <path
        d="M153.549 10.397l-.537-3.223c0-.538.269-1.075.537-1.88l.269-.27.806 5.105-1.075.268zm0-2.955l.269 2.687h.537l-.537-4.03c-.269.269-.269.806-.269 1.343z"
        fill="#131A2D"
      />
      <path
        d="M175.845 2.875c.537.537.806.806.806 1.343l.269 2.955h-.538l-.537-4.298z"
        fill="#fff"
      />
      <path
        d="M176.382 7.172l-.537-4.835.268.269c.538.537.806.806.806 1.343v.269l.537 2.954h-1.074zm-.269-4.029l.538 3.76h.268l-.268-2.685c0-.538-.269-.806-.538-1.075z"
        fill="#131A2D"
      />
      <path
        d="M155.429 3.95c.269-.268.537-.268.806-.537l.806 6.447h-.806l-.806-5.91z"
        fill="#fff"
      />
      <path
        d="M156.235 9.86l-.806-6.178c.269-.269.537-.269.806-.537h.269l.806 6.715h-1.075zm-.537-5.91l.806 5.642h.537l-.806-5.91c-.269 0-.537 0-.537.269z"
        fill="#131A2D"
      />
      <path
        d="M161.609.996c.269 0 .537 0 .806-.269l1.074 8.328h-.806l-1.074-8.06z"
        fill="#fff"
      />
      <path
        d="M162.683 9.323L161.609.996c.269 0 .537 0 .806-.269h.268l1.075 8.596H162.683zm-1.074-8.058l1.074 7.79h.538l-1.075-8.06s-.268.27-.537.27z"
        fill="#131A2D"
      />
      <path
        d="M156.772 3.144c.269-.269.537-.269.806-.269l.806 6.985h-.806l-.806-6.716z"
        fill="#fff"
      />
      <path
        d="M157.578 9.86l-.806-6.716c.269-.269.537-.269.806-.269h.269l1.074 7.253-1.343-.268zm-.806-6.716l.806 6.447h.537l-.806-6.447c-.268-.269-.268 0-.537 0z"
        fill="#131A2D"
      />
      <path
        d="M159.19 1.801c.269 0 .538-.269.806-.269l1.075 7.522h-.806l-1.075-7.253z"
        fill="#fff"
      />
      <path
        d="M159.997 9.591l-1.075-7.79c.269 0 .538-.269.806-.269h.269l1.074 7.79-1.074.269zm-.806-7.522l1.074 7.253h.538l-1.075-7.253c-.268-.268-.268-.268-.537 0z"
        fill="#131A2D"
      />
      <path
        d="M160.266 1.533c.269 0 .537-.27.806-.27l1.074 8.06h-.805l-1.075-7.79z"
        fill="#fff"
      />
      <path
        d="M162.415 9.323h-.806l-1.074-8.06c.268 0 .537-.268.806-.268h.268l.806 8.328zm-.806-.27h.537l-1.074-7.79c-.269 0-.269 0-.537.27l1.074 7.52z"
        fill="#131A2D"
      />
      <path
        d="M166.175 14.16c-6.984 1.074-12.356-1.344-12.625-3.761-.269-2.418 4.029-6.179 11.014-6.985 6.984-1.074 12.356 1.343 12.625 3.761.537 2.686-4.029 6.178-11.014 6.984z"
        fill="#fff"
      />
      <path
        d="M162.952 14.696c-2.149 0-4.029-.269-5.641-.806-2.418-.806-3.761-1.88-3.761-3.224-.268-2.686 4.298-6.178 11.283-7.252 3.223-.538 6.447-.27 8.864.537 2.418.806 3.761 1.88 4.03 3.223.268 2.687-4.298 6.179-11.283 7.253-1.343 0-2.417.269-3.492.269zm5.104-11.282c-1.074 0-2.149 0-3.223.268-6.985 1.075-11.283 4.298-11.014 6.984.269 1.344 1.612 2.418 3.761 3.224 2.417.806 5.641 1.074 8.596.537 6.984-1.074 11.282-4.298 11.013-6.984-.268-1.343-1.611-2.418-3.76-3.224-1.612-.537-3.493-.805-5.373-.805z"
        fill="#131A2D"
      />
      <path
        opacity={0.25}
        d="M157.311 5.83c.805-.537 1.611-.806 2.417-1.074l11.014 8.327c-.806.269-1.881.537-2.955.806L157.311 5.83zM163.757 3.682c.268 0 .537 0 1.074-.269h1.075l9.67 7.253c-.268.269-.805.537-1.074.806l-10.745-7.79z"
        fill="#fff"
      />
      <path
        d="M212.648 60.094c-.806-1.88-1.612-3.76-1.88-5.372l-4.298-9.402 3.492-1.612c3.223-1.075 9.133 3.224 13.163 11.55 4.029 8.328 3.223 15.85.268 17.461l-3.492 1.612-4.298-9.402c-1.074-1.343-2.149-2.955-2.955-4.835z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M219.901 74.6l-4.298-9.402c-1.074-1.612-2.149-3.224-2.955-5.104s-1.612-3.492-1.88-5.373l-4.298-9.402 3.761-1.88c3.223-1.075 9.401 3.223 13.162 11.55 4.03 8.328 3.492 15.85.537 17.462l-4.029 2.149zM206.47 45.588l4.298 9.133c.537 1.88 1.074 3.492 1.88 5.373.806 1.88 1.881 3.492 2.955 4.835l4.298 9.133 3.492-1.611c2.955-1.612 3.492-8.865-.537-17.192-3.761-8.328-9.939-12.626-12.894-11.283l-3.492 1.612z"
        fill="#131A2D"
      />
      <path
        d="M213.453 44.244c.269.268.806.268 1.074.537l-6.984 3.223-.537-.805 6.447-2.955z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M207.543 48.273l-.537-1.075 6.447-2.954c.269.268.806.268 1.074.537h.269l-7.253 3.492zm-.268-1.075l.268.538 6.447-2.955c-.268-.269-.537-.269-.806-.537l-5.909 2.955z"
        fill="#131A2D"
      />
      <path
        d="M215.066 64.392l9.67-4.567c0 .269.269.537.269 1.075l-9.402 4.298c-.268-.269-.537-.537-.537-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M215.603 65.197c-.269-.269-.269-.537-.538-.806l-.268-.268 9.939-4.567v.269c0 .268.269.537.269 1.074l-9.402 4.298zm-.538-.806c.269.269.269.537.538.537l9.133-4.298c0-.268 0-.537-.269-.806l-9.402 4.567z"
        fill="#131A2D"
      />
      <path
        d="M224.198 58.214c0 .268.269.537.269 1.074l-9.94 4.567c-.268-.269-.268-.537-.537-.806l10.208-4.835z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M214.527 63.854c-.268-.268-.537-.537-.537-1.074l10.208-4.835v.268c0 .269.269.538.269 1.075l-9.94 4.566zm-.268-1.074c0 .268.268.537.268.537l9.671-4.566c0-.27-.269-.538-.269-.806l-9.67 4.835z"
        fill="#131A2D"
      />
      <path
        d="M225.542 66.808v1.075l-7.253 3.223-.538-.806 7.791-3.492z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M218.288 71.375l-.537-1.074 8.059-3.761v1.343l-7.522 3.492zm0-.806l.269.538 6.984-3.224v-.806l-7.253 3.492z"
        fill="#131A2D"
      />
      <path
        d="M223.393 56.601c0 .269.269.537.269.806l-10.208 4.835c-.269-.268-.269-.537-.537-.806l10.476-4.835z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M213.722 62.51c-.268-.268-.268-.805-.537-1.074l10.476-4.835c0 .269.269.537.269.806l-10.208 5.104zm-.268-1.074c0 .269.268.538.268.538l9.939-4.567c0-.269-.268-.537-.268-.806l-9.939 4.835z"
        fill="#131A2D"
      />
      <path
        d="M225.542 68.689c0 .537-.268.806-.268 1.343l-5.91 2.686-.537-.806 6.715-3.223z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M219.095 72.987l-.537-1.074 6.984-3.224v.269c0 .537-.268.806-.268 1.343l-6.179 2.686zm-.268-1.074l.268.537 5.91-2.686c0-.269.269-.537.269-.806l-6.447 2.955z"
        fill="#131A2D"
      />
      <path
        d="M225.542 63.048c0 .268 0 .806.269 1.074l-8.597 4.03-.537-.806 8.865-4.298z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M216.945 68.42l-.537-1.074 9.134-4.298v.269c0 .268-.001.806.268 1.074l-8.865 4.03zm-.268-1.074l.268.537 8.328-4.029v-.806l-8.596 4.298z"
        fill="#131A2D"
      />
      <path
        d="M225.005 61.436c0 .268.269.806.269 1.074l-9.134 4.298-.537-.806 9.402-4.566z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M216.14 66.808l-.537-1.074 9.402-4.298v.268c0 .269.269.806.269 1.075l-9.134 4.03zm0-1.074l.269.537 8.865-4.03c0-.268 0-.537-.269-.805l-8.865 4.298z"
        fill="#131A2D"
      />
      <path
        d="M225.542 64.929v1.074l-8.058 3.761-.538-.806 8.596-4.029z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M217.752 70.033l-.537-1.074 8.596-4.03v1.343l-8.059 3.761zm-.269-1.074l.269.537 7.79-3.76v-.807l-8.059 4.03z"
        fill="#131A2D"
      />
      <path
        d="M218.02 47.736l.806.806-8.864 4.297-.538-.805 8.596-4.298z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M209.693 52.84l-.537-1.075 8.864-4.03.806.806-9.133 4.299zm-.269-.806l.269.537 8.596-4.03-.537-.537-8.328 4.03z"
        fill="#131A2D"
      />
      <path
        d="M222.05 53.377c.269.269.269.537.538.806l-10.208 4.835c0-.268-.269-.537-.269-.806l9.939-4.835z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M212.11 59.287c-.268-.537-.268-.806-.537-1.075l10.477-4.835c.268.269.268.537.537.806l-10.477 5.104zm0-1.075c0 .27.269.538.269.806l9.939-4.566c0-.269-.268-.538-.268-.538l-9.94 4.298z"
        fill="#131A2D"
      />
      <path
        d="M212.379 59.824l10.208-4.835s0 .268.268.268c0 .269.269.269.269.538l-10.208 4.835c0-.269-.268-.269-.268-.537 0 0 0-.269-.269-.269z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M212.916 60.899c0-.269 0-.269-.268-.269 0 0 0-.269-.269-.269v-.537l10.476-4.835v.537c0 .269.269.269.269.537v.269l-10.208 4.567zm-.268-1.075s0 .269 0 0c.268.269.268.537.268.537l9.939-4.835c0-.269 0-.269-.268-.537v-.269l-9.939 5.104z"
        fill="#131A2D"
      />
      <path
        d="M209.961 43.976a3.729 3.729 0 012.418 0l-5.641 2.686-.537-1.074 3.76-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M206.738 46.662l-.537-1.343 3.76-1.88a3.729 3.729 0 012.418 0h.269l-5.91 3.223zm-.269-1.075l.269.806 5.104-2.417c-.806-.269-1.612-.269-2.149 0l-3.224 1.611z"
        fill="#131A2D"
      />
      <path
        d="M224.736 71.107c-.269.806-.806 1.343-1.343 1.612L219.9 74.33l-.268-.806 5.104-2.418z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M219.632 74.33l-.538-1.075 5.641-2.686-.268.268c-.269.806-.806 1.343-1.343 1.612l-3.492 1.88zm0-.806l.268.537 3.492-1.612c.538-.269.806-.537 1.075-1.075l-4.835 2.15z"
        fill="#131A2D"
      />
      <path
        d="M215.065 45.318l.806.806-7.79 3.76-.537-.805 7.521-3.76z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M208.35 49.885l-.537-1.075 7.522-3.492.805.806h.269l-8.059 3.76zm-.268-1.075l.268.537 7.522-3.492c-.269-.268-.537-.268-.806-.537l-6.984 3.492z"
        fill="#131A2D"
      />
      <path
        d="M221.244 52.034c.268.269.268.537.537.806l-9.939 4.835c0-.268-.269-.537-.269-1.074l9.671-4.567z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M211.572 57.675c-.268-.537-.268-.806-.268-1.074l9.939-4.567c.268.269.268.537.537.806l-10.208 4.835zm-.268-1.074c0 .268.268.537.268.806l9.94-4.567c0-.269-.269-.537-.269-.537l-9.939 4.298z"
        fill="#131A2D"
      />
      <path
        d="M216.677 46.663l.806.806-8.328 4.03-.537-.807 8.059-4.03z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M208.886 51.498l-.537-1.075 8.328-3.76.805.805-8.596 4.03zm0-1.075l.269.537 8.059-3.76-.537-.538-7.791 3.761z"
        fill="#131A2D"
      />
      <path
        d="M219.094 49.08c.268.268.537.536.537.805l-9.402 4.298-.537-.806 9.402-4.298z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M210.498 54.452l-.537-1.075 9.133-4.298c.269.269.537.538.537.806l-9.133 4.567zm-.268-1.075l.268.538 9.133-4.298c-.268-.269-.268-.538-.537-.538l-8.864 4.298z"
        fill="#131A2D"
      />
      <path
        d="M220.169 50.422c.269.268.269.537.538.806l-9.671 4.566c0-.268-.268-.537-.268-1.074l9.401-4.298z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M211.036 56.063c-.268-.538-.268-.806-.268-1.075l9.401-4.566c.269.268.269.537.538.806l-9.671 4.835zm0-1.075c0 .269 0 .538.269.806l9.402-4.298c-.269-.269-.269-.537-.538-.537l-9.133 4.03z"
        fill="#131A2D"
      />
      <path
        d="M206.201 63.048c-4.029-8.596-3.223-16.117-.269-17.46 3.224-1.344 9.402 2.954 13.432 11.282 4.029 8.596 3.223 16.117.268 17.46-3.223 1.612-9.401-2.686-13.431-11.282z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M218.289 74.867c-3.492 0-8.596-4.298-12.088-11.82-1.881-4.028-2.955-8.058-2.687-11.55 0-3.224 1.075-5.373 2.687-6.178 3.223-1.612 9.402 2.954 13.431 11.55 1.88 4.03 2.955 8.06 2.686 11.551 0 3.224-1.074 5.373-2.686 6.179-.269.268-.806.268-1.343.268zm-11.82-11.82c4.03 8.597 10.208 12.895 13.163 11.283 1.612-.806 2.418-2.955 2.418-5.91 0-3.492-.806-7.521-2.687-11.282-4.029-8.596-10.207-12.894-13.162-11.282-1.612.806-2.418 2.955-2.418 5.91-.269 3.223.806 7.253 2.686 11.282z"
        fill="#131A2D"
      />
      <path
        opacity={0.25}
        d="M213.453 48.274c.806.806 1.612 1.611 2.417 2.686l-6.447 17.46c-.805-1.074-1.611-2.148-2.149-3.492l6.179-16.654zM218.826 55.795c.268.269.268.806.537 1.075.269.269.269.806.537 1.074l-5.641 15.312c-.537-.269-1.074-.806-1.612-1.074l6.179-16.387z"
        fill="#fff"
      />
      <path
        d="M89.616 48.005c-.269.537-.537.805-1.075 1.343 0 0-.268 0-.268-.269-.537 7.79 1.88 14.237 6.984 21.222.269.268 0 .805-.269 1.074-2.686 2.15-5.103 4.835-7.79 7.253h.269c0 .537.269 1.075.269 1.612H86.66c-.269 0-.269 0-.537-.269-6.716-7.79-10.477-16.655-10.477-25.52 0-.268.27-.805.806-1.074 4.03-2.418 8.06-3.223 12.088-5.372H89.617z"
        fill="#131A2D"
      />
      <path
        d="M89.617 48.542c-.806 8.327 1.88 15.043 7.522 22.296.268.269.268.806-.269 1.075-2.955 2.417-5.91 5.372-8.596 8.327-.269.269-.806.269-1.074 0-6.716-7.522-10.477-16.386-10.745-25.52 0-.268.268-.806.805-1.074 4.03-2.418 8.06-3.224 11.82-5.373.537-.268.806-.268.537.269z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M87.737 80.24c-.269 0-.537 0-.537-.27-6.716-7.79-10.477-16.654-11.014-25.519 0-.268.269-.806.806-1.074a52.536 52.536 0 016.984-3.224c1.612-.537 3.224-1.343 4.835-2.149.27-.268.538-.268.806 0 0 0 .269.269.269.538-.806 7.79 1.612 14.237 7.253 22.027.269.268.269.806-.269 1.074-3.223 2.687-5.91 5.373-8.596 8.328 0 .268-.268.268-.537.268zm1.612-31.967h-.269c-1.612.806-3.223 1.612-4.835 2.149a52.529 52.529 0 00-6.984 3.223c-.27.269-.538.538-.538 1.075.269 8.864 4.03 17.73 10.745 25.25l.269.27c.269 0 .269 0 .537-.27 2.686-2.954 5.641-5.64 8.596-8.327.269-.268.269-.537 0-.806-5.64-8.058-8.059-14.774-7.521-22.564.268 0 .268 0 0 0 .268 0 .268 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M88.005 51.227c.537-.268.806-.268.806.27 0 6.715 2.417 11.819 6.178 17.728.268.269 0 .806-.269.806-.268.269-.268.537-.268 1.075.268.268.268.806 0 1.074-1.88 1.612-3.761 3.224-5.373 5.104-.268.269-.806.269-.806 0-.268-.269-.537-.269-.806 0-.268.269-.805.269-.805 0-4.836-6.178-7.79-13.163-8.597-20.415 0-.269.27-.806.538-1.075.268-.268.537-.806.537-1.074v-.269c0-.269.269-.806.537-1.075 2.418-1.343 5.104-2.149 7.253-2.686.537 0 .537 0 .537.269v.268c-.268.27 0 .27.538 0z"
        fill="#fff"
      />
      <path
        d="M88.54 77.552c-.268 0-.536 0-.536-.268l-.269-.269s-.269 0-.269.269c-.268.268-.268.268-.537.268s-.537 0-.537-.268c-5.104-6.447-7.79-13.163-8.596-20.416 0-.269.268-.806.537-1.074.269-.269.537-.538.537-.806v-.269c0-.269.269-.806.806-1.074 2.418-1.344 4.835-2.15 7.253-2.687h.537s.269.269 0 .269v.537h.27c.268 0 .536-.268.536 0l.269.269c0 6.984 2.418 12.088 6.178 17.73.269.268.269.805-.268 1.074-.269.268-.269.537 0 .806.268.268.268.805 0 1.074-1.88 1.612-3.761 3.492-5.373 5.104 0-.269-.268-.269-.537-.269zm-.805-.806c.269 0 .537 0 .537.27l.269.268s.269 0 .269-.269c1.611-1.88 3.492-3.492 5.372-5.104.269-.268.269-.537 0-.806-.269-.268-.269-.806.269-1.074.268-.269.268-.537 0-.806-3.761-5.641-6.179-10.745-6.447-17.73v-.268h-.269c-.269 0-.537.269-.537 0l-.269-.269v-.268-.269h-.537c-2.418.537-4.835 1.343-6.984 2.686-.269.269-.538.538-.538.806v.269c0 .268-.268.806-.537 1.074-.269.269-.537.538-.537.806.806 6.985 3.76 13.969 8.596 20.416l.269.269s.268 0 .268-.27c.269.27.537.27.806.27z"
        fill="#131A2D"
      />
      <path
        d="M86.393 67.881c-1.611.269-3.223 0-4.566-1.074-1.88-1.612-1.612-4.835.537-6.447.806-.806 1.88-1.075 2.686-1.343 1.612-.269 2.955.268 4.03 1.343 1.612 1.612 1.611 4.298-.269 6.178-.537.806-1.343 1.075-2.418 1.343z"
        fill="#fff"
      />
      <path
        d="M83.169 60.63c1.88-1.612 4.298-1.612 5.64 0 1.344 1.611 1.344 4.03-.268 5.64-1.611 1.613-4.298 1.881-5.91.27-1.611-1.612-1.343-4.299.538-5.91z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M85.318 67.613c-1.074 0-2.149-.268-2.686-1.074-.806-.806-1.074-1.612-1.074-2.686 0-1.344.537-2.418 1.611-3.493 1.88-1.611 4.567-1.611 5.91 0 1.343 1.612 1.343 4.03-.268 5.642-1.075 1.343-2.418 1.611-3.493 1.611zm.806-8.058c-1.074 0-2.149.268-2.955 1.074-1.074.806-1.611 1.88-1.611 3.224 0 1.074.268 1.88 1.074 2.417 1.612 1.343 4.03 1.343 5.641-.268 1.612-1.612 1.612-3.761.269-5.373-.537-.537-1.343-1.074-2.418-1.074z"
        fill="#131A2D"
      />
      <path
        d="M89.616 71.373c-.537.537-1.611.537-1.88 0-.537-.537-.269-1.612.537-2.149.806-.537 1.612-.537 1.88.269.27.537 0 1.343-.537 1.88z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M88.542 71.911c-.537 0-.806-.268-1.075-.537-.537-.806-.268-1.88.538-2.418.268-.268.806-.537 1.343-.268.269 0 .537.268.806.537.537.806.268 1.612-.537 2.418-.27.268-.538.268-1.075.268zm.537-2.955c-.268 0-.537 0-.806.269-.537.537-.805 1.343-.537 2.149.269.269.269.537.806.537.269 0 .806 0 1.075-.268.537-.538.805-1.344.537-1.88-.269-.538-.537-.807-1.075-.807z"
        fill="#131A2D"
      />
      <path
        d="M83.707 57.136c-.806.537-1.612.269-1.612-.269 0-.805.537-1.611 1.343-2.149.806-.537 1.612-.268 1.612.269 0 .806-.538 1.612-1.343 2.149z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M82.9 57.674h-.537c-.268 0-.537-.269-.537-.806 0-.806.537-1.88 1.343-2.418.538-.268 1.075-.268 1.343-.268.27 0 .538.268.538.805 0 .806-.538 1.88-1.343 2.15-.27.268-.538.537-.806.537zm1.344-3.224c-.269 0-.537 0-.806.269-.806.537-1.343 1.343-1.343 2.149 0 .268.268.268.268.537.269 0 .806 0 1.075-.269.806-.537 1.343-1.343 1.074-2.149 0-.268-.268-.268-.268-.537.268 0 0 0 0 0zM108.153 49.348c-.538.269-1.075.538-1.344.806l-.268-.269c-3.761 6.985-4.298 13.7-2.687 22.028 0 .268-.268.806-.537.806-3.223.806-6.715 2.149-10.208 3.492h.27c0 .537-.27 1.074-.27 1.612-.268-.27-.537-.269-.805-.538-.27 0-.269-.268-.269-.268-2.686-9.94-2.418-19.341 1.343-27.669.269-.268.537-.537 1.075-.806 4.835-.537 8.596.269 13.162.269.269 0 .538 0 .538.269-.269 0-.269.268 0 .268z"
        fill="#131A2D"
      />
      <path
        d="M108.153 49.617c-4.298 7.253-4.567 14.506-2.686 23.102 0 .268-.269.806-.537.806-3.761 1.074-7.522 2.417-11.551 4.029-.269.269-.806 0-.806-.537-2.686-9.67-2.686-19.341.806-27.669.268-.268.537-.537 1.074-.806 4.835-.537 8.596.269 12.894.269.806.537.806.537.806.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M93.11 77.823h-.269c-.268 0-.268-.268-.268-.537-2.955-9.939-2.418-19.61 1.074-27.668.269-.269.806-.806 1.343-.806 2.687-.269 5.373 0 7.791 0 1.611 0 3.492.268 5.372.268.269 0 .537 0 .537.269v.537c-4.029 6.716-4.566 13.7-2.686 23.102 0 .537-.269.806-.537 1.075-4.03 1.074-7.79 2.417-11.282 4.029-.806-.269-.806-.269-1.075-.269zm4.567-28.743c-1.075 0-1.88 0-2.955.269-.537 0-.806.269-1.075.537-3.492 8.06-3.76 17.73-.806 27.4 0 .269 0 .269.27.269h.536c3.761-1.612 7.522-2.955 11.551-4.03.269 0 .537-.268.537-.537-2.149-9.67-1.343-16.655 2.687-23.37v-.269s-.269-.269-.269 0c-1.88 0-3.761 0-5.372-.269h-5.104z"
        fill="#131A2D"
      />
      <path
        d="M105.198 51.498c.537 0 .806.27.537.538-2.686 5.91-2.954 11.55-1.88 18.804 0 .268-.269.805-.537.805-.269 0-.537.538-.537.806 0 .269-.269.806-.538.806-2.417.806-4.835 1.343-6.984 2.418-.269 0-.806 0-.806-.537 0-.269-.537-.538-.806-.538-.268.269-.806 0-.806-.537-1.88-7.79-1.611-15.312.806-22.027 0-.269.538-.538 1.075-.806h.268c.538 0 .806-.269 1.075-.806v-.269c0-.268.537-.537 1.075-.537 2.954-.269 5.641.269 7.521.537.537 0 .537.269.537.538v.268c-.537.538-.268.538 0 .538z"
        fill="#fff"
      />
      <path
        d="M94.99 75.674h-.268c-.268 0-.268-.269-.268-.537 0-.27 0-.27-.269-.27h-.806c-.268 0-.269-.268-.269-.536-1.88-7.79-1.611-15.312.806-22.296 0-.269.538-.806 1.075-.806h.269c.268 0 .805-.269.805-.537v-.269c.27-.269.538-.806 1.075-.806 2.686-.268 5.372 0 7.79.537.269 0 .537 0 .537.269v.806h.269c.269 0 .537 0 .537.269v.537c-2.955 6.178-2.955 12.088-1.88 18.535 0 .537-.269.806-.537.806-.269 0-.538.268-.538.537 0 .537-.268.806-.537 1.075-2.418.805-4.835 1.611-6.984 2.417-.537.269-.537.269-.806.269zm-1.074-1.075h.269c.269 0 .269.269.269.538 0 .268 0 .268.268.268h.269c2.418-.806 4.567-1.612 6.984-2.417.269 0 .537-.27.537-.538 0-.537.269-.806.538-1.074.268 0 .537-.269.537-.537-1.075-6.716-1.075-12.357 1.88-18.804v-.269h-.268c-.269 0-.538 0-.538-.268v-.806-.269l-.537-.269c-2.417-.537-4.835-.806-7.521-.537-.269 0-.806.269-.806.537v.269c-.269.269-.537.806-1.075.806h-.268c-.269 0-.806.269-.806.537-2.418 6.716-2.686 14.237-.806 22.027 0 .27 0 .27.269.27h.268c.269.536.537.536.537.536z"
        fill="#131A2D"
      />
      <path
        d="M96.87 66.003c-1.611-.269-2.955-1.343-3.492-2.955-.806-2.418.537-4.835 3.224-5.641 1.074-.269 2.149-.269 2.955 0 1.611.537 2.686 1.612 2.955 2.955.537 2.149-.538 4.567-2.955 5.372-.806.538-1.612.538-2.687.27z"
        fill="#fff"
      />
      <path
        d="M96.87 57.944c2.418-.806 4.567.537 5.104 2.417.538 1.88-.537 4.03-2.686 4.836s-4.567 0-5.641-2.15c-.537-1.88.806-4.297 3.223-5.103z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M97.676 65.734c-1.88 0-3.492-1.075-4.03-2.686-.268-.806-.268-1.88.27-2.955.537-1.075 1.611-1.88 2.954-2.418 2.418-.806 4.835.269 5.373 2.418.537 2.149-.538 4.298-2.687 5.104-.537.537-1.074.537-1.88.537zm.537-7.79c-.537 0-.806 0-1.343.268-1.343.269-2.149 1.075-2.686 2.15-.537.805-.537 1.88-.269 2.686.806 1.88 3.224 2.954 5.373 2.149 2.149-.806 3.223-2.687 2.686-4.836-.537-1.343-1.88-2.417-3.76-2.417z"
        fill="#131A2D"
      />
      <path
        d="M98.214 70.57c-.806.269-1.611-.269-1.611-.806 0-.806.537-1.612 1.343-1.88.805-.269 1.611.268 1.611 1.074s-.537 1.343-1.343 1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M97.677 70.838c-.269 0-.538 0-.806-.268-.269-.269-.537-.537-.537-.806 0-.806.537-1.612 1.343-1.88.537 0 1.074 0 1.343.268.268.269.537.537.537.806 0 .806-.537 1.612-1.343 1.88h-.537zm.537-2.954h-.269c-.806.268-1.343 1.074-1.343 1.611 0 .269.269.538.537.806.269.269.806.269 1.075 0 .806-.268 1.343-1.074 1.343-1.612 0-.268-.269-.537-.537-.805h-.806z"
        fill="#131A2D"
      />
      <path
        d="M98.75 55.258c-.805 0-1.611-.268-1.342-1.074.268-.806 1.074-1.343 2.149-1.343.806 0 1.611.268 1.343 1.074-.269.537-1.075 1.075-2.15 1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M98.481 55.258c-.537 0-.805 0-1.074-.269-.269-.268-.269-.537-.269-.805.269-.806 1.075-1.344 2.15-1.612.537 0 1.074 0 1.342.268.269.269.269.538 0 .806-.268.806-1.074 1.343-2.149 1.612.269 0 .269 0 0 0zm1.343-2.418c-1.074 0-2.149.806-2.149 1.343v.538c.27.268.538.268 1.075.268.806 0 1.612-.805 1.88-1.343v-.537c0-.269-.268-.269-.806-.269zM77.26 67.077c2.418 1.344 6.447 1.344 8.865 0l40.562-23.37c.806-.537 2.418-.537 3.224 0s.806 1.343 0 1.88l-40.563 23.37c-4.298 2.418-10.208 3.493-15.043 0l2.955-1.88z"
        fill="#131A2D"
      />
      <path
        d="M74.573 68.958c4.298 2.417 10.208 2.417 14.237 0l40.832-23.37c.537-.27.537-.538.537-.807v46.741c0 3.224-1.612 6.179-4.567 7.79l-36.533 20.953c-4.298 2.418-11.014 3.224-15.043.806-1.88-1.074-2.955-3.492-3.224-4.835V64.66c.27 1.343 1.612 2.955 3.761 4.298z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M80.483 122.413c-2.418 0-4.567-.537-6.448-1.611-1.88-1.075-2.954-3.224-3.223-5.104V64.122h.269c0 1.343 1.343 3.223 3.492 4.566 4.03 2.418 9.939 2.418 14.237 0l40.831-23.37c.269-.269.537-.537.537-.806h.269v46.74c0 3.224-1.88 6.448-4.567 8.06l-36.533 20.952c-2.417 1.344-5.64 2.149-8.864 2.149zM71.08 65.465v50.501c.268 1.612 1.074 3.761 2.954 4.836 4.299 2.417 11.014 1.611 15.044-.806l36.533-20.953c2.686-1.612 4.566-4.567 4.566-7.79V45.318c0 .269-.268.269-.537.269L88.81 68.957c-4.298 2.418-10.208 2.418-14.506 0-1.343-.806-2.686-2.15-3.223-3.492z"
        fill="#131A2D"
      />
      <path
        d="M120.241 71.375l9.939-5.641a2.44 2.44 0 012.686 0l.537.268-14.505 15.58-1.612-.805c-.806-.538-1.075-1.344-1.075-2.687 0-2.417 1.881-5.372 4.03-6.715z"
        fill="#131A2D"
      />
      <path
        d="M122.121 71.913l10.476-5.91c.538-.269 1.344 0 1.344.806v5.104c0 1.343-.806 2.686-2.15 3.492l-10.207 5.91c-1.075.537-2.149.806-2.687.268-1.074-.537-1.343-2.149-1.074-4.298.806-2.149 2.149-4.298 4.298-5.372z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M119.972 82.12c-.537 0-.806 0-1.074-.268-1.075-.806-1.612-2.417-1.075-4.566.537-2.418 2.149-4.298 4.298-5.642l10.476-5.91c.269-.268.806-.268 1.344 0 .268.27.537.538.537 1.075v5.104c0 1.612-.806 2.955-2.149 3.76l-10.208 5.91c-1.074.27-1.612.538-2.149.538zm2.149-10.207c-1.88 1.343-3.223 3.224-3.761 5.373-.537 1.88-.268 3.492.806 4.029.537.269 1.612.269 2.418-.269l10.208-5.91c1.074-.805 1.88-1.88 1.88-3.223V66.81c0-.268 0-.537-.269-.537h-.806l-10.476 5.641z"
        fill="#131A2D"
      />
      <path
        d="M121.582 74.33c1.075-.806 2.149 0 2.149 1.343s-1.074 2.955-2.149 3.76c-1.074.807-2.149 0-2.149-1.342 0-1.344.806-3.224 2.149-3.761z"
        fill="#131A2D"
      />
      <path
        d="M121.852 75.136c1.074-.537 1.88 0 1.88 1.075 0 1.074-.806 2.417-1.88 3.223-1.075.538-1.881 0-1.881-1.074.269-1.343 1.075-2.686 1.881-3.224z"
        fill="#fff"
      />
      <path
        d="M121.315 79.433c-.269 0-.269 0-.538-.268-.268-.269-.537-.806-.537-1.343 0-1.075.806-2.687 1.881-3.224.537-.268 1.074-.268 1.343 0 .268.269.537.806.537 1.343 0 1.075-.806 2.687-1.88 3.224-.269.268-.538.268-.806.268zm.806-4.298c-1.075.538-1.612 1.88-1.612 2.955 0 .538.268.806.537 1.075.269.268.806 0 1.075 0 1.074-.537 1.611-1.88 1.611-2.955 0-.537-.268-.806-.537-1.075-.269-.268-.806-.268-1.074 0z"
        fill="#131A2D"
      />
      <path
        d="M112.181 80.777c-.268-1.075-.537-2.418-1.343-3.224-.806-1.074-2.149-1.612-3.492-1.612s-2.418.269-3.492.806c-2.149 1.075-3.492 2.686-4.835 4.567-1.344 1.88-2.15 3.76-2.687 5.91v.268c0 .269.269.269.538.269l4.029-2.418 4.029-2.417c-1.343.537-2.686 1.343-4.298 2.149l-3.223 1.611c.537-1.611 1.612-2.954 2.417-4.298a8.18 8.18 0 012.149-2.149c.806-.537 1.612-1.343 2.418-1.611.806-.538 1.88-.806 2.686-.538.806 0 1.612.269 2.149 1.075.538.537.806 1.612 1.075 2.417v2.955c-.269 1.88-1.075 3.761-2.149 5.642l-1.612 2.417a8.169 8.169 0 01-2.149 2.15c-.806.537-1.612 1.074-2.686 1.342-.806.269-1.88.269-2.686.269-.806-.269-1.612-.806-1.88-1.88-.538-.806-.538-1.88-.807-2.955v-.269c0-.269-.268-.269-.537 0-1.88 1.343-3.76 2.418-5.641 3.76 1.88-.805 3.76-1.88 5.372-2.954 0 .806.269 1.88.538 2.686.537 1.075 1.343 2.15 2.417 2.418 1.075.537 2.418.269 3.492 0 1.075-.269 2.149-.806 2.955-1.612.806-.537 1.612-1.343 2.418-2.149s1.343-1.612 1.88-2.686c1.075-1.88 1.881-4.03 2.418-6.179.806-1.343.806-2.686.537-3.76z"
        fill="#fff"
      />
      <path
        d="M100.631 97.164c-.538 0-1.075 0-1.88-.269-1.075-.537-2.15-1.343-2.418-2.417-.269-.806-.538-1.612-.538-2.686-1.88 1.074-3.76 1.88-5.372 2.686v-.269c1.88-1.343 3.76-2.418 5.641-3.76.269-.27.537 0 .537.268v.269c0 1.074.269 2.149.537 2.954.538.806 1.075 1.344 1.88 1.612.807.269 1.613.269 2.687-.268.806-.269 1.612-.806 2.418-1.344a8.169 8.169 0 002.149-2.148c.806-.806 1.343-1.612 1.612-2.418 1.074-1.88 1.88-3.76 2.149-5.641.268-1.075.268-2.15 0-2.955-.269-1.075-.538-1.88-1.075-2.418-.537-.537-1.343-1.074-2.149-1.074s-1.612.268-2.686.537c-.806.269-1.612.806-2.418 1.612-.806.537-1.343 1.343-2.149 2.149-1.074 1.343-1.88 2.686-2.418 4.03l2.687-1.344c1.612-.806 2.955-1.343 4.298-2.149v.269c-1.075.805-2.418 1.611-4.03 2.417l-4.029 2.418h-.537c-.269 0-.269 0-.269-.269v-.537c.537-2.149 1.612-4.03 2.686-5.91a18.889 18.889 0 014.836-4.566c1.074-.538 2.417-.806 3.492-.806 1.343 0 2.686.537 3.492 1.612.806.805 1.343 2.148 1.343 3.492.269 1.074.269 2.149 0 3.492a13.554 13.554 0 01-2.418 6.178c-.537.806-1.074 1.88-1.88 2.686-.806.806-1.612 1.612-2.418 2.15-1.074.805-2.149 1.343-2.954 1.611.537.806-.269.806-.806.806zm-4.567-5.641c0 1.343.269 2.149.537 2.955a5.27 5.27 0 002.418 2.417c1.343.538 2.686.269 3.492 0 1.075-.268 1.88-.805 2.955-1.611.806-.538 1.612-1.344 2.418-2.15.805-.805 1.343-1.88 1.88-2.686 1.074-1.88 1.88-4.029 2.418-6.178a7.684 7.684 0 000-3.492c-.269-1.343-.538-2.418-1.344-3.224-.805-.805-2.149-1.611-3.223-1.343-1.075 0-2.149.269-3.224.806-1.88 1.075-3.492 2.418-4.835 4.567-1.343 1.88-2.149 3.76-2.686 5.91v.268l.268.269h.27l4.029-2.418c.805-.537 1.343-.806 2.149-1.343-.806.269-1.344.806-2.149 1.075l-3.493 1.611v-.268c.538-1.612 1.612-2.955 2.418-4.298a8.172 8.172 0 012.149-2.15c.806-.805 1.612-1.343 2.418-1.611 1.074-.537 1.88-.806 2.686-.806s1.612.269 2.418 1.075c.537.537.805 1.611 1.074 2.417v2.955c-.269 1.88-1.074 3.76-2.149 5.641-.537.806-1.074 1.612-1.88 2.418a8.185 8.185 0 01-2.149 2.149c-.806.806-1.881 1.074-2.687 1.343-1.074.269-1.88.269-2.686.269-.806-.27-1.612-.806-2.149-1.88-.269-.807-.537-1.881-.806-2.956h-.268c-1.343.806-2.418 1.612-3.761 2.418.806-.806 1.88-1.612 3.492-2.15zM196.799 35.38c-.537 0-.806 0-1.343.268v.269c-6.447-1.88-10.745-4.836-15.312-9.134-.269-.268-.537-.268-.806-.268-2.149.806-4.835 1.343-7.253 1.88-.268-.268-.806-.268-1.074-.537 0 .269 0 .269-.269.537v.269c4.835 5.372 11.014 9.67 18.267 12.088h1.074c2.687-1.343 4.03-3.223 6.447-4.567l.269-.268v-.538z"
        fill="#131A2D"
      />
      <path
        d="M196.53 35.112c-6.715-1.88-11.551-4.835-16.117-9.402-.269-.269-.538-.269-.806-.269-2.686.806-5.373 1.612-8.328 2.15-.268 0-.268.268-.268.537 4.835 5.372 11.013 9.67 17.998 12.088h1.074c2.686-1.343 4.03-3.224 6.447-4.567.269-.268.269-.268 0-.537z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M189.546 40.484h-.537c-6.984-2.417-13.163-6.715-17.998-12.088 0 0-.269-.269 0-.537 0-.269.269-.269.269-.269 2.686-.537 5.641-1.343 8.327-2.149.269 0 .806 0 .806.269 5.104 5.104 9.939 7.79 16.117 9.402.269 0 .269.268.269.268s0 .269-.269.269c-1.074.537-1.88 1.343-2.686 1.88-1.074.806-2.149 1.88-3.761 2.687 0 .268-.268.268-.537.268zm-9.67-14.774c-.269 0 0 0 0 0-2.955.806-5.641 1.611-8.596 2.149h-.269v.268c4.835 5.373 11.014 9.671 17.998 12.089h.806c1.612-.806 2.686-1.88 3.761-2.687.805-.537 1.611-1.343 2.686-1.88-6.179-1.612-11.014-4.567-16.118-9.67 0-.27 0-.27-.268-.27z"
        fill="#131A2D"
      />
      <path
        d="M193.844 35.38c.269-.269.269-.269 0-.537-5.373-1.88-8.865-4.298-12.894-7.79-.269-.27-.537-.27-.806-.27s-.537 0-.806-.268c-.268-.268-.537-.268-.806-.268-1.611.537-3.223 1.074-5.104 1.343-.268 0-.268.268-.268.537.268.269 0 .537-.269.537-.268 0-.268.269-.268.537 4.029 4.03 8.864 7.522 14.505 9.671h.806c.269 0 .537-.269.806 0H189.815c1.611-.806 2.686-1.88 3.492-2.955.268-.269.268-.269 0-.269h-.269c.537 0 .537-.268.806-.268z"
        fill="#fff"
      />
      <path
        d="M187.934 39.409h-.537c-5.373-2.15-10.476-5.641-14.506-9.67 0 0-.268-.27-.268-.538s.268-.268.268-.268h.269c.268 0 0 0 0-.27 0-.268-.269-.268-.269-.536 0-.269.269-.269.269-.269 1.612-.537 3.492-.806 5.104-1.343.268 0 .806 0 .806.268.268.27.537.27.537.27.268 0 .806 0 .806.268 3.76 3.223 7.253 5.91 12.625 7.79.269 0 .269.269.269.269s0 .268-.269.268h.269s.268 0 .268.269c0 .268 0 .268-.268.268-1.075 1.075-1.881 2.15-3.492 2.955-.269.269-.806.269-1.075 0h-1.074c.805.269.537.269.268.269zm-9.133-12.625c-1.88.537-3.492 1.074-5.373 1.343h-.268v.268c0 .269.268.269.268.538 0 .268-.268.268-.268.268h-.269v.269c4.03 4.03 8.865 7.521 14.506 9.67h.806c.268 0 .806-.268 1.074 0H190.352c1.612-.806 2.686-1.88 3.492-2.955h-.269c-.268 0-.268-.268-.268-.268s0-.269.268-.269c-5.641-1.88-9.133-4.567-12.894-7.79-.268-.269-.537-.269-.537-.269-.269 0-.806 0-.806-.268 0-.538-.268-.538-.537-.538z"
        fill="#131A2D"
      />
      <path
        d="M180.413 31.888c-.538.805-.538 1.611 0 2.417 1.074 1.343 3.492 1.88 5.372 1.343.806-.268 1.343-.537 1.612-1.074.537-.806.269-1.612-.269-2.418-1.074-1.343-3.223-1.88-4.835-1.343-.806.269-1.612.537-1.88 1.075z"
        fill="#fff"
      />
      <path
        d="M185.516 35.38c1.612-.537 2.149-1.88 1.075-2.954-1.075-1.075-2.955-1.612-4.567-1.343-1.611.268-2.417 1.611-1.343 2.955 1.075 1.343 3.224 1.88 4.835 1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M184.174 35.65c-1.343 0-2.955-.538-3.492-1.612-.537-.538-.537-1.075-.269-1.612.269-.538.806-1.075 1.881-1.343 1.611-.269 3.492.268 4.566 1.343.538.537.538 1.074.538 1.611-.269.538-.806 1.075-1.612 1.344-.537.268-1.075.268-1.612.268zM183.1 31.35h-1.075c-.806.269-1.343.538-1.612 1.343-.268.538 0 1.075.269 1.612.806 1.075 2.955 1.612 4.567 1.075.805-.269 1.343-.806 1.343-1.343 0-.538 0-1.075-.538-1.344-.268-1.074-1.611-1.343-2.954-1.343z"
        fill="#131A2D"
      />
      <path
        d="M178.262 29.203c-.537.268-.806.537-.268 1.074.537.269 1.343.538 1.88.269.537-.269.537-.537.269-1.075-.538-.268-1.344-.268-1.881-.268z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M179.336 30.814c-.537 0-1.074-.269-1.343-.537-.268-.269-.268-.538-.268-.806 0-.269.268-.538.537-.538.537-.268 1.343 0 1.88.27.269.268.269.536.269.805s-.269.537-.537.537c-.269.269-.538.269-.538.269zm-1.074-1.343c-.269 0-.269.268-.537.268 0 .269 0 .269.268.538.269.268 1.075.537 1.612.268.269 0 .269-.268.537-.268 0 0 0-.269-.268-.538-.269-.268-1.075-.537-1.612-.268z"
        fill="#131A2D"
      />
      <path
        d="M188.47 35.917c-.537.27-.537.806 0 .806.538.269 1.343.269 1.881 0 .537-.268.537-.806 0-.806-.538-.268-1.343-.268-1.881 0z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M189.277 37.26c-.268 0-.537 0-.806-.268-.537-.269-.537-.537-.537-.537 0-.269.269-.538.537-.538.538-.268 1.343-.268 2.149 0 .269 0 .538.27.538.538s-.269.537-.538.537c-.537 0-1.074.269-1.343.269zm.269-1.343c-.269 0-.806 0-1.075.27-.268 0-.268.268-.268.268s0 .268.268.268c.538.269 1.343.269 1.881 0 .268 0 .268-.268.268-.268s0-.269-.268-.269c-.269-.269-.538-.269-.806-.269zM254.553 60.9c-.269.268-.806.536-1.075.536v-.268c-4.298 5.372-6.447 10.745-7.79 17.192 0 .268-.269.537-.537.537-2.418.806-4.836 1.612-7.522 2.686-.268.269-.537.806-.537 1.075-.269 0-.269-.269-.537-.269v-.268c.806-7.522 3.76-15.043 8.327-21.49.269-.27.537-.538.806-.538 3.224-.537 5.372.269 8.327 0h.269c.269.537.269.537.269.806z"
        fill="#131A2D"
      />
      <path
        d="M254.554 61.167c-4.567 5.641-6.985 11.282-8.059 17.998 0 .268-.269.537-.538.537a68.754 68.754 0 00-8.596 3.224c-.268 0-.537 0-.537-.27.806-7.52 3.492-15.042 8.059-21.49.269-.268.537-.536.806-.536 3.223-.538 5.372.268 8.327 0 .538 0 .806.268.538.537z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M237.361 82.927c-.268 0-.268 0 0 0-.268-.27-.537-.27-.268-.538.806-7.521 3.76-15.043 8.058-21.49.269-.269.538-.537 1.075-.537 1.88-.269 3.492-.269 4.835 0 1.075 0 2.149.268 3.492 0 .269 0 .269 0 .269.268v.538c-4.298 5.104-6.716 10.476-8.059 17.998 0 .268-.268.537-.537.806-3.224.806-5.91 1.88-8.865 2.955zm11.014-22.297c-.806 0-1.612 0-2.418.27-.268 0-.537.268-.806.536-4.566 6.447-7.252 13.7-8.058 21.222v.269h.268c2.687-1.344 5.641-2.15 8.596-3.224.269 0 .538-.269.538-.537 1.343-7.522 3.76-12.894 8.058-17.998h-3.76c-.806-.538-1.612-.538-2.418-.538z"
        fill="#131A2D"
      />
      <path
        d="M252.135 62.511c.269 0 .537.269.269.269-3.492 4.835-5.104 9.133-6.179 14.506 0 .268-.268.537-.537.537-.268 0-.537.269-.537.537 0 .269-.269.537-.537.537-1.612.538-3.493 1.075-5.104 1.88-.269 0-.538 0-.538-.268s-.268-.537-.537-.268c-.268 0-.537 0-.537-.269 1.074-5.91 3.223-11.82 6.447-17.192.269-.269.537-.537.806-.537s.537-.269.806-.538l.268-.268c.269-.269.538-.537.806-.537 1.881-.269 3.492 0 4.836.268.268 0 .268.269.268.269l-.268.269c0 .805 0 .805.268.805z"
        fill="#fff"
      />
      <path
        d="M238.972 81.315c-.268-.269-.268-.269-.268-.537v-.269h-.806s-.269-.268 0-.537c1.074-6.178 3.223-11.82 6.447-17.192.268-.269.537-.537.806-.537.268 0 .537-.269.805-.538l.269-.268c.269-.269.537-.537.806-.537 1.88-.269 3.492 0 4.835.268.269 0 .269 0 .269.269v.269l-.269.268v.269c.269 0 .269 0 .269.268v.538c-3.492 4.835-5.104 9.402-6.179 14.505 0 .269-.268.538-.537.806-.268 0-.537.269-.537.537 0 .27-.269.538-.537.806-1.612.269-3.224.806-5.373 1.612.269 0 .269 0 0 0zm-.268-1.074c.268.268.268.268.268.537v.269h.269c1.612-.806 3.492-1.344 5.104-1.88.268 0 .537-.27.537-.538 0-.269.269-.537.537-.806.269 0 .537-.269.537-.537 1.075-5.104 2.687-9.67 6.179-14.506v-.269c-.269 0-.269 0-.269-.268v-.538l.269-.268h-.269c-1.343-.269-2.955-.537-4.835-.269-.269 0-.537.269-.806.538l-.269.268c-.268.269-.537.537-.805.537-.269 0-.538.269-.806.538-3.224 5.372-5.641 11.013-6.447 17.192v.268h.268l.538-.268c-.269 0-.269 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M242.734 73.793c-1.075-.269-1.612-1.075-1.612-2.15 0-1.88 1.88-3.76 3.761-4.297.806-.269 1.343-.269 1.88 0 .806.268 1.343 1.074 1.075 2.149-.269 1.611-1.612 3.492-3.224 4.298-.537 0-1.074.268-1.88 0z"
        fill="#fff"
      />
      <path
        d="M245.15 67.614c1.612-.537 2.955.269 2.686 1.88-.268 1.612-1.343 3.224-2.955 3.761-1.611.537-2.955 0-2.955-1.612-.268-1.611 1.344-3.492 3.224-4.029z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M243.539 73.524c-.538 0-.806 0-1.075-.269-.537-.268-.806-1.074-.806-1.611 0-1.612 1.612-3.493 3.492-4.03.806-.268 1.612-.268 2.149.269.538.268.806 1.074.538 1.612-.269 1.611-1.612 3.223-3.224 4.029h-1.074zm2.417-5.91c-.268 0-.537 0-1.074.269-1.612.537-3.224 2.418-3.224 3.76 0 .538.269 1.075.537 1.344.538.268 1.344.268 2.149 0 1.612-.537 2.687-2.15 2.955-3.761 0-.537 0-1.075-.537-1.612h-.806z"
        fill="#131A2D"
      />
      <path
        d="M242.465 77.284c-.538.269-1.075 0-.806-.806.268-.537.806-1.343 1.343-1.343a.594.594 0 01.806.806 3.24 3.24 0 01-1.343 1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M242.196 77.553c-.269 0-.269 0-.538-.268-.268-.269-.268-.537-.268-.806.268-.537.806-1.343 1.343-1.612h.806c.268.269.268.537.268.806-.268.537-.806 1.343-1.343 1.343 0 .537-.268.537-.268.537zm1.074-2.417h-.269a3.24 3.24 0 00-1.343 1.343v.537h.538a3.24 3.24 0 001.343-1.343v-.537c0 .268 0 0-.269 0z"
        fill="#131A2D"
      />
      <path
        d="M247.031 65.466c-.537 0-.806-.269-.537-.806s1.075-1.074 1.612-1.074c.537 0 .806.268.537.806-.269.268-.806.805-1.612 1.074z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M246.763 65.466c-.269 0-.537 0-.537-.269 0 0-.269-.268 0-.806.268-.537 1.074-1.074 1.88-1.074.269 0 .537 0 .806.269v.805c-.269.538-1.074 1.075-2.149 1.075.269 0 .269 0 0 0zm1.612-1.88c-.806 0-1.612.537-1.881 1.074 0 .269-.268.269 0 .537 0 0 .269.269.538 0 .537 0 1.343-.537 1.611-1.074 0-.269.269-.269 0-.538h-.268zM216.945 113.012c-.269-.537-.269-1.074-.537-1.611h.268c-5.372-6.716-11.282-10.477-18.804-13.432-.268 0-.537-.537-.537-.806-.268-3.223-.806-6.447-1.343-9.67-.537-.269-.806-.806-1.343-1.075l.537-.537h.269c8.864 2.955 17.192 8.328 23.908 15.312.268.268.537.806.537 1.343-.269 4.029-1.612 6.716-2.149 10.208 0 .268 0 .268-.269.268h-.537z"
        fill="#131A2D"
      />
      <path
        d="M216.676 112.745c-5.641-6.984-11.819-11.014-19.878-14.237-.269 0-.537-.537-.537-.806-.269-3.492-.806-7.253-1.881-11.014 0-.268.269-.537.538-.537 8.864 2.955 17.192 8.059 23.907 15.043.269.269.538.806.538 1.343-.269 4.03-1.612 6.447-2.149 10.208 0 .269-.269.269-.538 0z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M216.945 113.012s-.269 0-.269-.268c-5.372-6.447-11.282-10.745-19.878-14.237-.269-.27-.537-.538-.806-1.075-.268-3.76-1.074-7.253-1.612-11.014 0-.268 0-.537.269-.537 0 0 .269-.269.537 0 9.134 2.955 17.461 8.059 23.908 15.043.269.269.537.806.537 1.343-.268 2.418-.537 4.298-1.074 5.91-.269 1.343-.806 2.686-1.075 4.029-.268.806-.268.806-.537.806zm-22.027-26.594c-.269 0-.269 0 0 0-.269 0-.269.269-.269.269.806 3.76 1.343 7.253 1.88 11.014 0 .268.269.537.538.806 8.596 3.492 14.505 7.521 19.878 14.237h.269v-.269c.268-1.612.537-2.955 1.074-4.029.537-1.881 1.075-3.761 1.075-5.91 0-.269-.269-.806-.269-1.075-6.984-6.984-15.043-12.088-24.176-15.043z"
        fill="#131A2D"
      />
      <path
        d="M215.602 109.519c0 .538-.269.538-.537.269-4.836-5.373-9.671-8.327-16.118-11.014-.269-.268-.537-.537-.537-.806 0-.268-.269-.805-.537-.805-.269 0-.538-.538-.538-.806-.268-2.15-.537-4.567-1.074-6.716 0-.269.268-.537.537-.537s.537 0 .537-.537c0-.27.269-.538.538-.538 6.984 2.687 13.431 6.716 19.072 12.088.269.269.537.806.537 1.075 0 .269.269.806.537 1.074l.269.269c.269.269.537.806.537 1.075-.268 2.417-1.074 4.298-1.611 5.641-.269.268-.269.268-.538 0 0 0 0-.269-.268-.269-.806.269-.806.269-.806.537z"
        fill="#fff"
      />
      <path
        d="M215.333 110.057s-.269 0-.269-.269c-5.104-5.641-9.939-8.596-16.117-11.013-.269-.269-.538-.538-.806-1.075 0-.269-.269-.537-.537-.806-.269-.268-.806-.537-.806-.806-.269-2.149-.538-4.566-1.075-6.715 0-.269 0-.269.269-.538h.806v-.268c0-.269 0-.269.268-.537h.538c7.252 2.686 13.699 6.715 19.072 12.088.269.268.537.806.537 1.343 0 .268.269.806.537 1.074l.269.269c.269.269.537.806.537 1.343-.268 2.418-.806 4.029-1.611 5.641 0 .269-.269.269-.269.269-.269 0-.269 0-.269-.269 0 0 0-.268-.268-.268h-.269v.268c-.269.269-.537.269-.537.269zM196.26 89.104c-.268 0-.268.269-.268.269.537 2.149.806 4.566 1.074 6.715 0 .269.269.538.538.806.268.269.805.537.805 1.075 0 .268.269.537.538.806 5.909 2.686 11.013 5.641 16.117 11.282h.269v-.269c0-.268.268-.268.268-.268s.269 0 .538.268c0 0 0 .269.268.269h.269v-.269c.806-1.612 1.343-3.492 1.612-5.641 0-.269-.269-.806-.269-1.074l-.269-.269c-.268-.269-.537-.806-.537-1.343 0-.269-.268-.806-.537-1.075-5.641-5.372-12.088-9.402-19.072-12.088h-.269v.269c0 .268 0 .268-.269.537h-.806c.269 0 .269 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M204.051 95.553c.537-1.075 1.612-1.612 2.955-1.343 2.149.537 4.298 2.955 4.566 5.641 0 1.074 0 1.88-.537 2.418-.537 1.074-1.612 1.343-2.955.805-2.149-.537-3.761-2.686-4.298-5.103 0-1.075 0-1.88.269-2.418z"
        fill="#fff"
      />
      <path
        d="M211.035 99.581c.269 2.149-1.074 3.492-2.955 2.955-1.88-.537-3.492-2.418-3.76-4.567-.269-2.149.806-3.76 2.686-3.223 2.149.268 3.761 2.686 4.029 4.835z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M209.155 102.804c-.269 0-.538 0-.806-.268-1.881-.538-3.492-2.687-4.03-4.836-.268-1.074 0-2.149.806-2.955.538-.537 1.344-.806 2.149-.537 1.881.537 3.761 2.686 4.03 5.104 0 1.075-.269 2.149-.806 2.686-.537.538-.806.806-1.343.806zm-2.687-8.059c-.537 0-1.074.269-1.343.538-.537.537-.806 1.611-.537 2.686.269 2.149 1.88 4.029 3.761 4.567.806.268 1.343.268 1.88-.269.538-.537.806-1.343.806-2.418-.268-2.149-2.149-4.566-3.761-4.835-.537-.269-.537-.269-.806-.269z"
        fill="#131A2D"
      />
      <path
        d="M200.021 94.21c0-.806.269-1.075 1.075-.806.806.268 1.343 1.343 1.343 1.88 0 .806-.537 1.074-1.074.806-.806-.269-1.344-1.075-1.344-1.88z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M201.902 96.358h-.537c-.806-.269-1.344-1.343-1.344-2.15 0-.536 0-.805.269-1.074.269-.268.537-.268.806 0 .806.269 1.343 1.343 1.343 2.15 0 .537 0 .805-.268 1.074h-.269zm-1.881-2.15c0 .807.538 1.613 1.344 1.881.268 0 .537.269.537 0 .268 0 .269-.268.269-.806 0-.806-.538-1.611-1.344-1.88h-.537c0 .269-.269.537-.269.806z"
        fill="#131A2D"
      />
      <path
        d="M213.184 102.806c0-.806.537-1.075 1.074-.538.537.538 1.075 1.612 1.075 2.418s-.538 1.074-1.075.537c-.537-.537-1.074-1.612-1.074-2.417z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M214.795 105.492c-.268 0-.537 0-.537-.269-.537-.537-1.074-1.612-1.074-2.418 0-.537.268-.805.537-.805.268 0 .537 0 .806.268.537.537 1.074 1.612 1.074 2.418-.268.268-.268.806-.806.806.269 0 0 0 0 0zm-1.343-2.687c0 .806.269 1.612.806 2.149.269.269.537.269.537.269.269 0 .269-.269.269-.537 0-.806-.269-1.881-.806-2.149-.269-.269-.537-.269-.537-.269-.269 0-.269.269-.269.537zM130.985 32.156c.269 0 .538-.269 1.075-.269v.269c4.029-3.492 6.447-7.522 8.327-12.357 0-.269.269-.269.538-.537 1.88-.269 4.029-.538 6.178-1.075l.806-.806.268.269v.269c-1.611 5.64-4.835 11.282-9.402 15.58-.268.268-.537.268-.805.268-2.687 0-4.298-.805-6.447-1.074h-.269c-.269-.269-.269-.269-.269-.537z"
        fill="#131A2D"
      />
      <path
        d="M131.254 32.156c4.298-3.761 6.984-7.79 8.596-12.894 0-.269.268-.269.537-.538 2.149-.268 4.567-.805 6.984-1.343.269 0 .269 0 .269.269-1.612 5.641-4.835 11.014-9.133 15.58-.269.269-.538.269-.806.269-2.418 0-4.298-.806-6.447-1.075-.269 0-.269-.268 0-.268z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M137.701 33.768c-1.612 0-2.686-.269-4.029-.538-.806-.268-1.612-.537-2.687-.537-.268 0-.268-.268-.268-.268s0-.269.268-.269c4.03-3.492 6.716-7.253 8.596-12.894 0-.269.269-.537.538-.537 2.417-.269 4.566-.806 6.984-1.343h.537v.268c-1.612 5.91-4.835 11.283-9.402 15.58.269.27-.268.538-.537.538zm-6.447-1.612c1.075.269 1.88.269 2.686.537 1.075.269 2.418.538 3.761.538.269 0 .537 0 .537-.27 4.298-4.297 7.522-9.67 9.134-15.58h-.269c-2.418.538-4.567 1.075-6.984 1.344-.269 0-.269.268-.538.268-1.611 5.91-4.298 9.67-8.327 13.163z"
        fill="#131A2D"
      />
      <path
        d="M133.134 31.35c-.268 0-.268-.269-.268-.269 3.223-3.223 5.104-6.447 6.715-10.476 0-.269.269-.269.538-.269.268 0 .537-.268.537-.537s.268-.269.537-.537c1.343-.269 2.955-.538 4.298-.806.269 0 .269 0 .269.268 0 .27 0 .27.268.27.269 0 .269 0 .269.268-1.612 4.566-4.029 8.864-7.522 12.357-.268.268-.537.268-.806.268-.268 0-.537 0-.805.269v.268c-.269.269-.538.269-.806.269-1.612 0-2.687-.537-3.761-.806-.269 0-.269-.268 0-.268h.269c.537-.27.537-.27.268-.27z"
        fill="#fff"
      />
      <path
        d="M136.895 32.962c-1.612 0-2.686-.538-3.761-.806 0 0-.268 0-.268-.269 0 0 0-.268.268-.268h.269c-.269 0-.269 0-.269-.27v-.268c3.492-3.223 5.373-6.447 6.716-10.476 0-.269.269-.537.537-.537.269 0 .269-.27.538-.27 0-.268.268-.536.537-.536 1.343-.269 2.955-.538 4.298-.806h.268v.268h.269v.27c-1.612 4.566-4.029 8.864-7.522 12.625-.268.268-.537.268-.805.268-.269 0-.538 0-.538.269l-.268.268c.537.538 0 .538-.269.538zm-3.761-1.075c1.075.537 2.418.806 3.761 1.075.269 0 .537 0 .537-.269v-.269c.269-.268.538-.268.806-.268.269 0 .537 0 .537-.269 3.224-3.76 5.91-7.79 7.522-12.357h-.269v-.268c-1.343.268-2.954.537-4.298.806-.268 0-.268.268-.537.268 0 .269-.269.537-.537.537-.269 0-.269.27-.537.27-1.612 3.76-3.493 7.252-6.985 10.476.269 0 .269 0 .269.268.269-.537.269-.268-.269 0z"
        fill="#131A2D"
      />
      <path
        d="M141.999 23.828c.806.27 1.074 1.075.806 1.88-.269 1.344-1.881 2.687-3.493 2.956-.537 0-1.074 0-1.611-.269-.537-.268-.806-1.074-.538-1.88.269-1.343 1.612-2.418 3.224-2.955.537 0 1.343 0 1.612.268z"
        fill="#fff"
      />
      <path
        d="M139.582 28.127c-1.343.269-2.149-.537-1.881-1.88.269-1.075 1.612-2.418 2.955-2.686 1.343-.269 2.418.537 2.149 1.611-.537 1.612-1.88 2.955-3.223 2.955z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M139.044 28.395c-.537 0-1.074-.268-1.343-.537-.268-.269-.268-.806-.268-1.343.268-1.343 1.611-2.418 2.955-2.687.805-.268 1.343 0 1.88.538.269.268.537.806.268 1.343-.268 1.343-1.611 2.418-3.223 2.686h-.269zm2.149-4.298h-.537c-1.343.269-2.418 1.343-2.686 2.418 0 .537 0 .806.269 1.074.268.269.805.538 1.611.269 1.343-.269 2.687-1.343 2.955-2.418 0-.537 0-.806-.269-1.074-.537-.269-1.074-.269-1.343-.269z"
        fill="#131A2D"
      />
      <path
        d="M142.805 21.142c.538 0 .806.269.538.537-.269.538-.806.806-1.343.806-.538 0-.806-.268-.538-.537.269-.537.806-.806 1.343-.806z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M141.999 22.754c-.269 0-.538 0-.538-.269v-.537c.269-.538.806-.806 1.344-1.075.268 0 .537 0 .805.269v.537c-.268.537-1.074 1.075-1.611 1.075zm.806-1.612c-.538 0-1.075.537-1.075.806v.268h.537c.538 0 1.075-.537 1.075-.806v-.268h-.537z"
        fill="#131A2D"
      />
      <path
        d="M137.432 29.738c.538 0 .538.27.269.806-.269.269-1.075.538-1.612.538-.537 0-.537-.269-.269-.806.538-.269 1.344-.538 1.612-.538z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M136.358 31.081c-.537 0-.537-.268-.537-.268s0-.269.268-.538c.269-.268 1.075-.805 1.612-.805.269 0 .537 0 .537.268 0 0 0 .269-.268.537-.269.538-1.075.806-1.612.806zm1.075-1.343c-.538 0-1.075.269-1.344.537 0 0-.268.269 0 .269 0 0 .269 0 .269.269.537 0 1.075-.269 1.343-.538 0 0 .269-.268 0-.268.269 0 0-.269-.268-.269zM227.152 28.933c.269-.268.269-.537.537-.806h.269c.806-5.372.269-9.939-1.343-14.774 0-.269 0-.537.268-.806 1.344-1.343 2.687-2.955 4.03-4.835V6.637h.537s.269 0 .269.269c2.417 5.641 3.223 11.82 2.686 17.998 0 .268-.269.537-.537.806-2.149 1.611-3.761 1.88-5.91 3.223h-.269c-.537.269-.537 0-.537 0z"
        fill="#131A2D"
      />
      <path
        d="M227.152 28.665c1.075-5.642.269-10.477-1.611-15.58 0-.27 0-.538.268-.538 1.612-1.612 2.955-3.492 4.567-5.372.268-.269.268-.269.537 0a33.585 33.585 0 012.686 17.998c0 .268-.268.537-.537.805-2.149 1.612-3.761 1.88-5.641 3.224-.269-.269-.537-.269-.269-.537z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M227.152 29.202c-.269 0-.269-.269-.269-.269.806-5.372.537-9.939-1.612-15.58 0-.269.001-.537.269-.806a43.804 43.804 0 004.567-5.372c0-.269.268-.269.268-.269s.269 0 .269.269c2.418 5.64 3.492 11.82 2.955 17.998 0 .268-.269.537-.537.805-1.075.806-2.418 1.344-3.492 1.88-.538.27-1.344.538-2.418 1.344.268 0 0 0 0 0zm3.223-22.027l-4.835 5.64s-.268.27 0 .538c2.149 5.641 2.418 10.208 1.612 15.58.806-.537 1.612-.805 2.418-1.343 1.074-.537 2.149-1.074 3.223-1.88.269-.269.269-.537.269-.537.806-6.447 0-12.357-2.687-17.998.269 0 0 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M227.957 26.784c-.268.268-.268 0-.268-.269.537-4.567 0-8.327-1.343-12.357 0-.268 0-.537.268-.537.269-.269.269-.537.269-.537v-.537c1.074-1.075 1.88-2.15 2.955-3.224.268-.269.268-.269.537 0 0 .269.269.269.537 0 .269-.269.269-.269.538 0 1.611 4.567 2.417 9.402 2.149 14.237 0 .269-.269.538-.269.806-.269.269-.269.537-.269.806v.269c0 .268-.268.537-.268.806-1.343.805-2.418 1.343-3.492 1.611-.269 0-.269 0-.269-.268-.806-.538-.806-.538-1.075-.806.538 0 .269 0 0 0z"
        fill="#fff"
      />
      <path
        d="M228.496 27.589c-.269 0 0 0 0 0l-.269-.269v-.268h-.269s-.268 0 0-.269c.538-4.835-.268-8.327-1.343-12.357 0-.268 0-.537.269-.806 0 0 .269-.268 0-.537 0-.268 0-.537.268-.806 1.075-1.074 1.881-2.149 2.955-3.223l.269-.269s.269 0 .269.269l.268-.269s.269 0 .269.269c1.612 4.566 2.418 9.402 2.149 14.506 0 .268-.269.537-.269.806-.268 0-.268.268-.268.537v.268c0 .269-.269.538-.538.806-1.343.806-2.417 1.075-3.76 1.612zm-.269-1.074c.269 0 .269.268.269.268v.269c1.074-.269 2.149-.806 3.492-1.612.268 0 .268-.269.268-.537v-.269c0-.268.269-.537.269-.806.269 0 .269-.268.269-.537.268-4.835-.538-9.67-2.149-14.237l-.269.268s-.269 0-.269-.268c-.805 1.074-1.88 2.149-2.955 3.223 0 0-.268.269 0 .538 0 .268.001.537-.268.805 0 0-.269.269 0 .538 1.343 4.03 1.88 7.521 1.343 12.357 0 0-.269 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M230.107 15.503c.806-.269 1.611 0 1.88.805.806 1.344.269 3.224-.806 4.567-.537.537-.806.806-1.343.806-.806 0-1.343-.269-1.612-1.075-.537-1.343-.268-2.954.538-4.298.268-.537.805-.805 1.343-.805z"
        fill="#fff"
      />
      <path
        d="M230.913 20.605c-1.075 1.075-2.149.806-2.687-.269-.537-1.074-.268-2.686.538-3.76.805-1.075 2.149-1.075 2.686 0 .806 1.074.537 2.954-.537 4.029z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M229.569 21.41c-.805 0-1.074-.537-1.343-1.074-.537-1.074-.268-2.955.538-4.03.537-.537 1.074-.805 1.611-.805.538 0 .806.268 1.075.806.537 1.074.268 2.955-.806 4.298 0 .537-.537.805-1.075.805zm.806-5.64c-.537 0-1.074.268-1.343.805-.806 1.075-1.074 2.687-.537 3.761.269.537.537.806.806.806.537 0 1.074-.269 1.343-.806 1.074-1.074 1.343-2.955.806-3.76 0-.538-.537-.807-1.075-.807.269 0 .269 0 0 0z"
        fill="#131A2D"
      />
      <path
        d="M229.033 12.815c.268-.268.806-.268.806.269s0 1.075-.269 1.612c-.269.268-.806.268-.806-.269-.269-.537 0-1.343.269-1.612z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M229.032 14.965c-.268 0-.537-.269-.537-.537 0-.538 0-1.075.537-1.612.269-.269.538-.269.538-.269.268 0 .268.269.537.538.269.537 0 1.343-.537 1.611-.269 0-.269.269-.538.269zm0-2.149c-.268.269-.537.806-.268 1.343 0 .269 0 .269.268.269 0 0 .269 0 .269-.269.269-.269.537-1.074.269-1.343 0-.269 0-.269-.269-.269 0 .269 0 .269-.269.269z"
        fill="#131A2D"
      />
      <path
        d="M230.376 22.754c.268-.269.806-.269.806.268 0 .538-.269 1.075-.806 1.343-.269.269-.806.269-.806-.268 0-.538.537-.806.806-1.343z"
        fill={theme["#0EA59D"]}
      />
      <path
        d="M230.107 24.903c-.269 0-.269 0 0 0-.269 0-.537-.268-.537-.537 0-.537.268-1.075.806-1.612.268-.268.537-.268.537-.268s.269.268.269.537c0 .537-.269 1.343-.806 1.612 0 .268-.269.268-.269.268zm.806-2.149s-.269 0-.269.269c-.268.268-.537.806-.806 1.343v.269h.269c.269-.269.806-.806.806-1.344v-.537z"
        fill="#131A2D"
      />
    </svg>
  )
}

export default SvgComponent
